import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Form, useNavigate } from 'react-router-dom';
import PageModal from '../../../components/common/PageModal';
import FacilityDetails from './FacilityDetails';
import EnrollmentDetails from './EnrollmentDetails';
import HierarchyDetails from './HierarchyDetails';
import LocationDetails from './LocationDetails';
import CoverageDetails from './CoverageDetails';
import endpoints from '../../../config/endpoints';
import config from '../../../config/config';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import {
  create_facilitydetails,
  facility_enrollmentdetails,
  hierarchy_details_urban,
  hierarchy_details_rural,
  location_details,
  coverage_details,
  AbdmInfo,
  coverage_details_urban,
  health_facility_creation_coverage_details
} from '../../../constants';
import './FacilityManagement.css';
import axios from '../../../utils/axiosExt';
import BreadcrumbComponent from '@components/common/Breadcrumb';
import NationalEmblem from '../../../assets/svg_main/national_emblem.svg';
import BackArrowsvg from '../../../assets/svg_main/BackArrowIconSvg.svg';
import { Link } from 'react-router-dom';
import Button from '@components/common/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Nav, Navbar, NavDropdown, Offcanvas } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import ProgressBarComponent from '@components/common/ProgressBar';
import CloseModal from '@components/common/CloseModal';
import CreateCommonComponent from '@components/common/CreateComponent';
import Auth from './../../../utils/auth';

import { WithPermission } from './../../../components/Auth/withPermission';
import { PagePermission } from './../../../services/usePermission';
import { getData, postDataJSON, putDataJSON } from './../../../services/CommonApiService';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine.js";
import { setCreateMapPincodeWithHfr, setGeometryMapPoint, setMapLatLong, setMapManualAddress, setMapManualLatLong, setMapManualLatLongClicked, setMapPincodeFirstTimeEdit, setMapServicesDown } from '@store/actions/facilityGeoMapAction';
import { errorLogger } from '@utils/applicationLogUtils';
import isUsingGramPanchayatUtils from '@utils/isUsingGrampanchayatUtil';
import _ from 'lodash';
import { manageHealthFacilityJson } from '@utils/commonUtils';
import pako from 'pako';
import { uint8ToBase64, decodeWithKeyAndShift } from '@utils/base64Utils';
import { USER_TYPES } from '@constants/userTypes';
import { checkUserRole, roleType } from '@constants/approvalConstants';


interface newUserProps {
  // closeModal?: () => void;
  show?: boolean;
  // finishModal?: () => void;
  page: string;
  flow: string;
}

interface objectType {
  isError: boolean,
  message: string,
  isDisable: boolean,
  value: any,
  id?: any,
  verifiedDetails?: any,
  isModalOpen?: boolean,
  code?: any,
}

interface formStateType {
  [key: string]: objectType
}

interface formDataType {
  [key: string]: any;
}


const CreateNewFacility: React.FC<newUserProps> = ({ show, page, flow }) => {
  const dropdownOptions = ['Option 1', 'Option 2', 'Option 3'];
  //Modal Pages
  const navItemsModal = [
    'Facility Details',
    'Enrollment Details',
    'Hierarchy Details',
    'Location Details',
    'Coverage Details',
  ];

  const navigate = useNavigate();
  
   const encodedUserData = localStorage.getItem('userDetails');
   const LogedinUserDetails: any = encodedUserData ? JSON.parse(decodeWithKeyAndShift(encodedUserData)) : '';
   const encodedUserRoles = localStorage.getItem('userRoleDetails');
   const userRolesDetails = encodedUserRoles ? JSON.parse(decodeWithKeyAndShift(encodedUserRoles)).split(', ') : [];
   const roleData = checkUserRole(userRolesDetails);

  const [ABDMdata, setABDMdata] = useState<any>({});

  const [formData2, setFormData2] = useState<any>(facility_enrollmentdetails);

  const [errors, setErrors] = useState<boolean[]>([]);
  const [ulbInputText, setUlbInputText] = useState<string>('');

  const [wardsPayLoad, setWardssPayLoad] = useState<any>(null);
  const [villagesPayLoad, setVillagesPayLoad] = useState<any>(null);
  const [wardsCount, setWardsCount] = useState<any>(0);
  const [villagesCount, setVillagesCount] = useState<any>(0);

  const [facilityDetailsFormState, setFacilityDetailsFormState] = useState<formStateType>({
    hpr_id: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      verifiedDetails: ''
    },
    facility_category: {
      isError: false,
      message: '',
      isDisable: false,
      id: [],
      code: [],
      value: [],
    },
    facility_name: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
    },
    facility_type: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    ownership: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    administrative_body: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    central_govt_dept: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    rural_urban: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
  });
  const [enrollmentDetailsFormState, setEnrollmentDetailsFormState] = useState<formStateType>({
    date_of_enrollment: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    effective_from_date: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    status: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    sanctionedbed_count: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    functionalbed_count: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
    }
  });

  const [isLinkedFacilityAvailable, setIsLinkedFacilityAvailable] = useState<boolean>(false);
  const [hierarchyDetailsFormState, setHierarchyDetailsFormState] = useState<formStateType>({
    state: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: ''
    },
    district: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
      id: '',
      code: ''
    },
    ulb: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    sub_district: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    block: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    health_block: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    sub_division: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    village: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    ward: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    parlimentary: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    lac: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
  });


  const [hierarchyDetailsRuralFormState, setHierarchyDetailsRuralFormState] = useState<formStateType>({
    state: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
      id: '',
      code: '',
    },
    district: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
      id: '',
      code: '',
    },
    sub_district: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    block: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    health_block: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    sub_division: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    village: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    gram_panchayat: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code:''
    },
    parlimentary: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    lac: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
  });
 // Hiherarchy Details Rural

 const [formData3_2, setFormData3_2] = useState<any>(hierarchy_details_rural);

  const [hierarchyDetailsUrbanFormState, setHierarchyDetailsUrbanFormState] = useState<formStateType>({
    state: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
      id: '',
      code: '',
    },
    district: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
      id: '',
      code: ''
    },
    ulb: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    sub_district: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    health_block: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    sub_division: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    ward: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    parlimentary: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    lac: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
  });

  const [locationDetailsFormData, setLocationDetailsFormData] = useState<any>(location_details);
  const [locationDetailsFormState, setLocationDetailsFormState] = useState<formStateType>({
    pincode: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    lattitude: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    longitude: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    address: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
  });
  
  // code for map
  const dispatch = useDispatch();
  const facilityGeoMap = useSelector((state: RootState) => state.facilityGeoMap);

  const clearMapStore = () => {
    dispatch(setGeometryMapPoint({mapPointer: '', distFenceGeometry: ''}));
    dispatch(setMapManualAddress(false));
    dispatch(setMapLatLong(null));
    dispatch(setMapManualLatLong(false));
    dispatch(setMapManualLatLongClicked(false));
    dispatch(setMapPincodeFirstTimeEdit(null));
    dispatch(setCreateMapPincodeWithHfr(null));
    dispatch(setMapServicesDown(false));
  }
  //====================


  const [coverageDetailsFormState, setCoverageDetailsFormState] = useState<formStateType>({
    linked_facilities: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id: [],
      code: [],
      isModalOpen: false,
    },
    wards_covered: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id: [],
      code: [],
      isModalOpen: false,
    },
    villages_covered: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id: [],
      code: [],
      isModalOpen: false,
    },
    gram_panchayat_covered: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id: [],
      code: [],
      isModalOpen: false,
    },
  });

  const [formData5, setFormData5] = useState<any>(health_facility_creation_coverage_details);


  // Modal window code - create new facility
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [isFormValidated, setIsFormValidated] = useState<boolean>(false);
  const [formCompleted, setFormCompleted] = useState<boolean[]>(
    Array(navItemsModal.length).fill(false),
  );
  const [isGrampanchayat, setIsGrampanchayat] = useState<boolean>(false); 
  const [HBSDSelected, setHBSDSelected] = useState<boolean>(false); 
  const [selectPerc, setSelectedPerc] = useState<any>(0);
  const navs = 100 / navItemsModal.length;
  const checkIfUsingGramPanchayatCoverage =async ()=>{
    const stateCode=hierarchyDetailsRuralFormState.state?.code||hierarchyDetailsUrbanFormState.state?.code
    if(stateCode){
      let isUsingGramPanchayat: boolean = false;
      isUsingGramPanchayat = await isUsingGramPanchayatUtils(stateCode);
      setIsGrampanchayat(isUsingGramPanchayat);
      setFormData5((coverage_details_rural: { villages_covered: any, gram_panchayat_covered:any }) => ({
        ...coverage_details_rural,
        villages_covered: {
          ...coverage_details_rural.villages_covered,
          '#isVisible': isUsingGramPanchayat ? false : true,      
        },
        gram_panchayat_covered: {
          ...coverage_details_rural.gram_panchayat_covered,
          '#isVisible': isUsingGramPanchayat ? true : false, 
        },
      }));
    }
  }
  const checkIfUsingGramPanchayat =async () =>{
    await checkIfUsingGramPanchayatCoverage();
    if(hierarchyDetailsRuralFormState.state?.code){
      try {
        let isUsingGramPanchayat: boolean = false;
        isUsingGramPanchayat = await isUsingGramPanchayatUtils(hierarchyDetailsRuralFormState.state?.code);
        setIsGrampanchayat(isUsingGramPanchayat);
        setFormData3_2((hierarchy_details_rural:any) => ({
          ...hierarchy_details_rural,
          village:{
            ...hierarchy_details_rural?.village,
            '#isVisible': isUsingGramPanchayat ? false : true,      
          },
          gram_panchayat:{
            ...hierarchy_details_rural?.gram_panchayat,
            '#isVisible': isUsingGramPanchayat ? true : false, 
          }
        }));
        setFormData5((coverage_details_rural: { villages_covered: any, gram_panchayat_covered:any }) => ({
          ...coverage_details_rural,
          villages_covered: {
            ...coverage_details_rural.villages_covered,
            '#isVisible': isUsingGramPanchayat ? false : true,      
          },
          gram_panchayat_covered: {
            ...coverage_details_rural.gram_panchayat_covered,
            '#isVisible': isUsingGramPanchayat ? true : false, 
          },
        }));
      }     catch(error:any){
             errorLogger(error?.response?.data||error?.response||error)
          }
    }
    else{
      setFormData3_2((hierarchy_details_rural:any) => ({
        ...hierarchy_details_rural,
        village:{
          ...hierarchy_details_rural?.village,
          '#isVisible': false ,      
        },
        gram_panchayat:{
          ...hierarchy_details_rural?.gram_panchayat,
          '#isVisible': false, 
        }
      }));
      setFormData5((coverage_details_rural: { villages_covered: any, gram_panchayat_covered:any }) => ({
        ...coverage_details_rural,
        villages_covered: {
          ...coverage_details_rural.villages_covered,
          '#isVisible': false
        },
        gram_panchayat_covered: {
          ...coverage_details_rural.gram_panchayat_covered,
          '#isVisible': false
        },
      }));
    }
  }

  useEffect(() => {
    const fetchLinkedFacilitiesUrban = async () => {
      try {
        // const id = '7c503764-6962-4e87-a31e-be3c9af4ee91'
        const ulbId = hierarchyDetailsUrbanFormState?.ulb?.id;
        const healthBlockId = hierarchyDetailsUrbanFormState?.health_block?.id;
        const subDivisionId = hierarchyDetailsUrbanFormState?.sub_division?.id;
        const facilityTypeId = facilityDetailsFormState?.facility_type?.id;
        const selectedULB = hierarchyDetailsUrbanFormState.ulb.value;
        let getLinkedFacility: any = [];
        let getWard_options: any = [];
        if (ulbId && facilityTypeId) {
          const data={
            "ulbId":ulbId,
            "facilityTypeId":facilityTypeId,
            "facilityId":"00000000-0000-0000-0000-000000000000" /*default facility id for create facility */
          }
          getLinkedFacility = await axios.post(`${endpoints.getLinkedFacilitiesByUlbId}`,data, Auth.loggedInWithJSON());
        }
        if (ulbId && !healthBlockId && !subDivisionId) {
          setHBSDSelected(false);
          const params = {
            'ulbId': ulbId,
            'healthBlockId': "",
            'subDivisionId': "",
          }
          setWardssPayLoad(params);
          const getWardsCoveredRes = await axios.post(`${endpoints.fetchWardByUlbHBSD}`,params, Auth.loggedIn());
          setWardsCount(getWardsCoveredRes.data.meta.numberOfRecords)
           getWard_options = getWardsCoveredRes.data.data.map((key: any) => ({
            value: `${selectedULB} - ${key.ward_name} - ${key.ward_code}`,
            label: `${selectedULB} - ${key.ward_name} - ${key.ward_code}`,
            id: key.ward_id,
            code: key.ward_code,
          }));
          setFormData5((coverage_details_urban: {  wards_covered: any,villages_covered:any,gram_panchayat_covered:any }) => ({
            ...coverage_details_urban,
            wards_covered: {
              ...coverage_details_urban.wards_covered,
              // '#options': [],
              '#options': getWard_options,
            },
            villages_covered: {
              ...coverage_details_urban.villages_covered,
               '#options': [],
            },
            gram_panchayat_covered: {
              ...coverage_details_urban.gram_panchayat_covered,
               '#options': [],           
            },
          }));
        }
      
        if (getLinkedFacility.data.data.length !== 0) {
          setFormData5((coverage_details_urban: { linked_facilities: any}) => ({
            ...coverage_details_urban,
            linked_facilities: {
              ...coverage_details_urban.linked_facilities,
              // '#options': [],
              '#options': getLinkedFacility.data.data,
              '#required': false,

            }
          }));
          setIsLinkedFacilityAvailable(true)
        }
        else {
          setFormData5((coverage_details_urban: { linked_facilities: any}) => ({
            ...coverage_details_urban,
            linked_facilities: {
              ...coverage_details_urban.linked_facilities,
              // '#options': [],
              '#options': [],
              '#required': false,

            },
          }));
          setIsLinkedFacilityAvailable(false)
        }

        //------ 
        setCoverageDetailsFormState((coverageDetailsFormState: any) => ({
          ...coverageDetailsFormState,
          linked_facilities: {
            ...coverageDetailsFormState.linked_facilities,
            value: [],
            id: [],
            code: [],
          },
          wards_covered: {
            ...coverageDetailsFormState.wards_covered,
            value: [],
            id: [],
            code: [],
            isError: false,
          },
          villages_covered: {
            ...coverageDetailsFormState.villages_covered,
            value: [],
            id: [],
            code: [],
            isError: false,
          },
          gram_panchayat_covered: {
            ...coverageDetailsFormState.gram_panchayat_covered,
            value: [],
            id: [],
            code: [],
            isError: false,
          },
        }));
      }
      catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }
    }
    fetchLinkedFacilitiesUrban();
  }, [hierarchyDetailsUrbanFormState?.ulb?.id, hierarchyDetailsUrbanFormState?.health_block?.id, hierarchyDetailsUrbanFormState?.sub_division?.id, facilityDetailsFormState?.facility_type?.id])

  useEffect(() => {
    const fetchLinkedFacilitiesRural = async () => {
      try {
        // const id = 'd2bcaee8-f739-4bf6-a5e3-a7276b8a1065'
        const blockId = hierarchyDetailsRuralFormState?.block?.id;
        const facilityTypeId = facilityDetailsFormState?.facility_type?.id;
        const healthBlockId = hierarchyDetailsRuralFormState?.health_block?.id;
        const subDivisionId = hierarchyDetailsRuralFormState?.sub_division?.id;
        let getLinkedFacility: any = [];
        if (blockId && facilityTypeId) {
          const data={
            "blockId":blockId,
            "facilityTypeId":facilityTypeId,
            "facilityId":"00000000-0000-0000-0000-000000000000"   /*default facility id for create facility */
          }
          getLinkedFacility = await axios.post(`${endpoints.getLinkedFacilitiesByblockId}`,data, Auth.loggedInWithJSON());
        }
        if (blockId && !healthBlockId && !subDivisionId ) {
          setFormData5((coverage_details_rural: { villages_covered: any, gram_panchayat_covered: any,wards_covered:any }) => ({
            ...coverage_details_rural,
            wards_covered: {
              ...coverage_details_rural.wards_covered,
              '#options': [],
            }
          }));
        }
        if (getLinkedFacility.data.data.length !== 0) {
          setFormData5((coverage_details_rural: { linked_facilities: any }) => ({
            ...coverage_details_rural,
            linked_facilities: {
              ...coverage_details_rural.linked_facilities,
              // '#options': [],
              '#options': getLinkedFacility.data.data,
              '#required': false,
            },
          }));
          setIsLinkedFacilityAvailable(true)
        }
        else {
          setFormData5((coverage_details_rural: { linked_facilities: any }) => ({
            ...coverage_details_rural,
            linked_facilities: {
              ...coverage_details_rural.linked_facilities,
              // '#options': [],
              '#options': [],
              '#required': false,
            },
          }));
          setIsLinkedFacilityAvailable(false)
        }
        setCoverageDetailsFormState((coverageDetailsFormState: any) => ({
          ...coverageDetailsFormState,
          linked_facilities: {
            ...coverageDetailsFormState.linked_facilities,
            value: [],
            id: [],
            code: [],
          },
          wards_covered: {
            ...coverageDetailsFormState.wards_covered,
            value: [],
            id: [],
            code: [],
            isError: false,
          },
          villages_covered: {
            ...coverageDetailsFormState.villages_covered,
            value: [],
            id: [],
            code: [],
            isError: false,
          },
          gram_panchayat_covered: {
            ...coverageDetailsFormState.gram_panchayat_covered,
            value: [],
            id: [],
            code: [],
            isError: false,
          },
        }));
      }
      catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }
    }
    fetchLinkedFacilitiesRural();
  }, [hierarchyDetailsRuralFormState?.block?.id,hierarchyDetailsRuralFormState?.health_block?.id, hierarchyDetailsRuralFormState?.sub_division?.id, facilityDetailsFormState?.facility_type?.id])
  const fetchVillagesGramPanchayatWardsCoveredByHBSD = async () => {
    try {
      const healthBlockId =facilityDetailsFormState?.rural_urban?.value==='Rural'? hierarchyDetailsRuralFormState?.health_block?.id:hierarchyDetailsUrbanFormState?.health_block?.id;
      const subDivisionId =facilityDetailsFormState?.rural_urban?.value==='Rural'? hierarchyDetailsRuralFormState?.sub_division?.id:hierarchyDetailsUrbanFormState?.sub_division?.id;
      if(healthBlockId || subDivisionId){
        setHBSDSelected(true);
      let getVillagesCovered: any = [];
      let getGramPanchayatsCovered: any = [];
      const paramsRural = {
        'blockId': "",
        'healthBlockId': healthBlockId,
        'subDivisionId': subDivisionId,
      }
      if (( healthBlockId || subDivisionId) && !isGrampanchayat) {
        setVillagesPayLoad(paramsRural);
        getVillagesCovered = await axios.post(`${endpoints.fetchVillageByBlockHBSD}`, paramsRural,Auth.loggedIn());
        setVillagesCount(getVillagesCovered.data.meta.numberOfRecords);
      }
      else{
        getGramPanchayatsCovered = await axios.post(`${endpoints.fetchGramPanchayatByBlockHBSD}`, paramsRural,Auth.loggedIn());

      }
      const params = {
        'ulbId': "",
        'healthBlockId': healthBlockId,
        'subDivisionId': subDivisionId,
      }
      setWardssPayLoad(params);
      const getWardsCoveredRes = await axios.post(`${endpoints.fetchWardByUlbHBSD}`,params, Auth.loggedIn());
      setWardsCount(getWardsCoveredRes.data.meta.numberOfRecords)
      const getWard_options = getWardsCoveredRes.data.data.map((key: any) => ({
        value: `${key.ward_name} - ${key.ward_code}`,
        label: `${key.ward_name} - ${key.ward_code}`,
        id: key.ward_id,
        code: key.ward_code,
      }));
        setFormData5((coverage_details_rural: { wards_covered: any, villages_covered: any,gram_panchayat_covered:any }) => ({
          ...coverage_details_rural,
          wards_covered: {
            ...coverage_details_urban.wards_covered,
            '#options': getWard_options,
          },
          villages_covered: {
            ...coverage_details_rural.villages_covered,
            '#options': getVillagesCovered?.data?.data,
          },
          gram_panchayat_covered: {
            ...coverage_details_rural.gram_panchayat_covered,
            '#options': getGramPanchayatsCovered?.data?.data,
          }
        }));      

      setCoverageDetailsFormState((coverageDetailsFormState: any) => ({
        ...coverageDetailsFormState,
        wards_covered: {
          ...coverageDetailsFormState.villages_covered,
          value: [],
          id: [],
          code: [],
          isError: false,
        },
        villages_covered: {
          ...coverageDetailsFormState.villages_covered,
          value: [],
          id: [],
          code: [],
          isError: false,
        },
        gram_panchayat_covered: {
          ...coverageDetailsFormState.gram_panchayat_covered,
          value: [],
          id: [],
          code: [],
          isError: false,
        },
      }));
    }
    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  }
  useEffect(() => {
    fetchVillagesGramPanchayatWardsCoveredByHBSD();
  }, [ hierarchyDetailsRuralFormState?.health_block?.id, hierarchyDetailsRuralFormState?.sub_division?.id,hierarchyDetailsUrbanFormState?.health_block?.id, hierarchyDetailsUrbanFormState?.sub_division?.id])

  const [formData1, setFormData1] = useState<any>(create_facilitydetails);
  /* Dropdowns Fetch start here  */
  /*get rural urban*/
  useEffect(() => {
    const fetchRuralOrUrban = async () => {
      try {
        const ruralOrUrban = await axios.getWithCache(`${endpoints.getRuralUrbal}`, Auth.loggedIn());
        const ruralOrUrban_options = ruralOrUrban.data.data.map((key: any) => (
          {
            value: key?.urban_rural_name === 'rural' ? 'Rural' : 'Urban',
            label: key?.urban_rural_name === 'rural' ? 'Rural' : 'Urban',
            id: key?.urban_rural_id
          }
        ));

        setFormData1((create_facilitydetails: { rural_urban: any }) => ({
          ...create_facilitydetails,
          rural_urban: {
            ...create_facilitydetails.rural_urban,
            '#options': ruralOrUrban_options,
            '#isDisabled': false
          }
        }));
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,
          facility_category: {
            ...facilityDetailsFormState.facility_category,
            value: [],
          },
        }));

      }
      catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }
    }

    fetchRuralOrUrban();
  }, [facilityDetailsFormState?.rural_urban?.id]);

  /* get Facility category and Type*/
  useEffect(() => {
    const fetchFacilityType = async () => {
      try {
        const facility_typeResponse = await axios.get(endpoints.getFacilityType, Auth.loggedIn());
        const facility_type_options = facility_typeResponse.data.data.map((key: any) => ({
          value: key.facility_type,
          label: key.facility_type,
          id: key.facility_type_id
        }));

        setFormData1((create_facilitydetails: { facility_category: any; facility_type: any; ownership: any; }) => ({
          ...create_facilitydetails,
          // facility_category: {
          //   ...create_facilitydetails.facility_category,
          //   '#options': [],
          // },
          facility_type: {
            ...create_facilitydetails.facility_type,
            '#options': facility_type_options,

          },

        }))
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,
          ownership: {
            ...facilityDetailsFormState.ownership,
            value: '',
            id:'',
            code:'',
          },
        }));
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,
          administrative_body: {
            ...facilityDetailsFormState.administrative_body,
            value: '',
            id:'',
            code:'',
          },
          central_govt_dept: {
            ...facilityDetailsFormState.central_govt_dept,
            value: '',
            id:'',
            code:'',
          },
          facility_category: {
            ...facilityDetailsFormState.facility_category,
            value: '',
            id:'',
            code:'',
          },
        }));
      }
      catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }
    };
    fetchFacilityType();
  }, [facilityDetailsFormState?.facility_type?.id]);

  /* get Facility category and Type*/
  useEffect(() => {
    if (facilityDetailsFormState?.facility_type?.id && facilityDetailsFormState?.rural_urban?.id) {
      checkIfUsingGramPanchayat();
      const fetchFacilityCategory = async () => {
        try {
          const facility_categoryResponse = await axios.get(`${endpoints.getFacilityCatByFacilityTypeIdRuralOrUrban(facilityDetailsFormState.facility_type.id,facilityDetailsFormState.rural_urban.id)}`, Auth.loggedIn());
          const facility_category_options = facility_categoryResponse.data.data.map((key: any) => ({
            value: key.facility_category,
            label: key.facility_category,
            id: key.facility_category_id,
            code: key.facility_category_code,
          }));

          

          setFormData1((create_facilitydetails: { facility_category: any; ownership: any; }) => ({
            ...create_facilitydetails,
            facility_category: {
              ...create_facilitydetails.facility_category,
              '#options': facility_category_options,
            },

          }))
          setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
            ...facilityDetailsFormState,
            ownership: {
              ...facilityDetailsFormState.ownership,
              value: '',
              id:'',
              code:'',
            },
            administrative_body: {
              ...facilityDetailsFormState.administrative_body,
              value: '',
              id:'',
              code:'',
            },
            central_govt_dept: {
              ...facilityDetailsFormState.central_govt_dept,
              value: '',
              id:'',
              code:'',
            },
          }));

        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
      };
      setFormData5((coverage_details_rural: { wards_covered:any,villages_covered: any, gram_panchayat_covered:any }) => ({
        ...coverage_details_rural,
        wards_covered: {
          ...coverage_details_rural.wards_covered,
          '#options':[],      
        },
        villages_covered: {
          ...coverage_details_rural.villages_covered,
          '#options':[],      
        },
        gram_panchayat_covered: {
          ...coverage_details_rural.gram_panchayat_covered,
          '#options': [], 
        },
      }));
      fetchFacilityCategory();
    }
    else {
      setFormData1((create_facilitydetails: { facility_category: any; ownership: any; }) => ({
        ...create_facilitydetails,
        facility_category: {
          ...create_facilitydetails.facility_category,
          '#options': [],
        },
      }))
    }
  }, [facilityDetailsFormState?.facility_type?.id, facilityDetailsFormState?.rural_urban?.id]);

  /* Get Ownership and Administrative Body */

  useEffect(() => {
    const fetchOwnership = async () => {
      if (facilityDetailsFormState?.facility_type?.id) {
        try {
          const facility_OwnershipResponse = await axios.get(`${endpoints.getOwnerByFacilityTypeId(facilityDetailsFormState.facility_type.id)}`, Auth.loggedIn());
          const facility_ownership_options = facility_OwnershipResponse.data.data.map((key: any) => ({
            value: key.ownership,
            label: key.ownership,
            id: key.owenership_id
          }));

          setFormData1((create_facilitydetails: { ownership: any; administrative_body: any }) => ({
            ...create_facilitydetails,
            ownership: {
              ...create_facilitydetails.ownership,
              '#options': facility_ownership_options,
              '#isDisabled': false,
              '#required': true,
            },
            administrative_body: {
              ...create_facilitydetails.administrative_body,
              '#options': []
            },
          }));
          
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
      } else {
        setFormData1((create_facilitydetails: { ownership: any; administrative_body: any }) => ({
          ...create_facilitydetails,
          ownership: {
            ...create_facilitydetails.ownership,
            '#options': []
          },
          administrative_body: {
            ...create_facilitydetails.administrative_body,
            '#options': []
          },
        }));
      }
    };
    fetchOwnership();
  }, [facilityDetailsFormState?.facility_type?.id]);

  useEffect(()=>{
    const fetchAdminbody = async () => {
      if (facilityDetailsFormState?.ownership?.id && facilityDetailsFormState?.facility_type?.id) {
        try {
          const facility_adminBody = await axios.get(`${endpoints.getAdminBody(facilityDetailsFormState?.facility_type?.id, facilityDetailsFormState?.ownership?.id)}`, Auth.loggedIn());
          const facility_adminBody_options = facility_adminBody.data.data.map((key: any) => ({
            value: key.admin_body,
            label: key.admin_body,
            id: key.admin_body_id
          }));

          setFormData1((create_facilitydetails: { ownership: any; administrative_body: any }) => ({
            ...create_facilitydetails,
            administrative_body: {
              ...create_facilitydetails.administrative_body,
              '#options': facility_adminBody_options,
              '#isDisabled': false,
              '#required': facility_adminBody_options.length > 0,
            },
          }));

          if (facility_adminBody_options?.length === 1) {
            const selectedAdminBody = facility_adminBody_options[0];
            setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
              ...facilityDetailsFormState,
              administrative_body: {
                ...facilityDetailsFormState.administrative_body,
                value: selectedAdminBody.value,
                id: selectedAdminBody.id,
              },
            }));
          }
          else{
            setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
              ...facilityDetailsFormState,
              administrative_body: {
                ...facilityDetailsFormState.administrative_body,
                value: '',
                id: '',
                code:'',
              },
            }));
          }
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
      } else {
        setFormData1((create_facilitydetails: { ownership: any; administrative_body: any }) => ({
          ...create_facilitydetails,
          administrative_body: {
            ...create_facilitydetails.administrative_body,
            '#options': [],
          },
        }));
        setFacilityDetailsFormState((facilityDetailsFormState: any) => ({
          ...facilityDetailsFormState,
          administrative_body: {
            ...facilityDetailsFormState.administrative_body,
            value: '',
            id: '',
            code:'',
          },
        }));
      }
    };
    fetchAdminbody();
  },[facilityDetailsFormState?.ownership?.id])

  /*get Central Government Department*/
  useEffect(() => {
    let facility_centralGovtDept;
    if (facilityDetailsFormState.administrative_body.id && facilityDetailsFormState.facility_type.id) {
      const fetchCentalGovtDept = async () => {
        try {
          facility_centralGovtDept = await axios.getWithCache(`${endpoints.getCentralGovtDeptByFacTypeIdAdminBodyId}/${facilityDetailsFormState.facility_type.id}/${facilityDetailsFormState.administrative_body.id}`, Auth.loggedIn());
          const facility_centralGovtDept_options = facility_centralGovtDept.data.data.map((key: any) => ({
            value: key.central_govt_dept_name,
            label: key.central_govt_dept_name,
            id: key.central_govt_dept_id
          }));
          if (facilityDetailsFormState.facility_type.value !== 'Defence Hospital' || facilityDetailsFormState.facility_type.value !== 'ESI Hospital' || facilityDetailsFormState.facility_type.value !== 'Railway Hospital') {
            if (facilityDetailsFormState.administrative_body.value !== "Central Government") {
              setFormData1((create_facilitydetails: { central_govt_dept: any }) => ({
                ...create_facilitydetails,
                central_govt_dept: {
                  ...create_facilitydetails.central_govt_dept,
                  '#options': [],
                  '#isDisabled': true,
                  '#required': false
                }
              }))
            }
            else {
              if (facility_centralGovtDept.data.data.length !== 0) {
                setFormData1((create_facilitydetails: { central_govt_dept: any }) => ({
                  ...create_facilitydetails,
                  central_govt_dept: {
                    ...create_facilitydetails.central_govt_dept,
                    '#options': facility_centralGovtDept_options,
                    '#isDisabled': false,
                    '#required': true,
                  }
                }))
              }
              else {
                setFormData1((create_facilitydetails: { central_govt_dept: any }) => ({
                  ...create_facilitydetails,
                  central_govt_dept: {
                    ...create_facilitydetails.central_govt_dept,
                    '#options': facility_centralGovtDept_options,
                    '#isDisabled': false,
                    '#required': false,
                  }
                }))
              }
            }
          }
          else {
            if (facility_centralGovtDept.data.data.length !== 0) {
              setFormData1((create_facilitydetails: { central_govt_dept: any }) => ({
                ...create_facilitydetails,
                central_govt_dept: {
                  ...create_facilitydetails.central_govt_dept,
                  '#options': facility_centralGovtDept_options,
                  '#isDisabled': false,
                  '#required': true,
                }
              }))
            }
            else {
              setFormData1((create_facilitydetails: { central_govt_dept: any }) => ({
                ...create_facilitydetails,
                central_govt_dept: {
                  ...create_facilitydetails.central_govt_dept,
                  '#options': facility_centralGovtDept_options,
                  '#isDisabled': false,
                  '#required': false,
                }
              }))
            }
          }
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
      }
      fetchCentalGovtDept();
    }
    else {
      setFormData1((create_facilitydetails: { central_govt_dept: any }) => ({
        ...create_facilitydetails,
        central_govt_dept: {
          ...create_facilitydetails.central_govt_dept,
          '#options': [],
          '#isDisabled': true,
          '#required': false
        }
      }))
    }
  }, [facilityDetailsFormState?.facility_type?.id, facilityDetailsFormState?.administrative_body?.value]);

  //Effective From Date
  useEffect(() => {
    const effectiveFromDate = async () => {
      try {
        const today = new Date();
        const maxDate = today.toISOString().split('T')[0];
        //calculating the date 365 days ago
        const oneYearAgo = new Date();
        oneYearAgo.setDate(today.getDate() - 365);
        const oneYearAgoDate = oneYearAgo.toISOString().split('T')[0];
        const getEntrollmentDate = enrollmentDetailsFormState.date_of_enrollment.value;
        if (dayjs(getEntrollmentDate).format('YYYY-MM-DD') >= oneYearAgoDate && dayjs(getEntrollmentDate).format('YYYY-MM-DD') <= maxDate) {
          setEnrollmentDetailsFormState((enrollmentDetailsFormState: any) => ({
            ...enrollmentDetailsFormState,
            effective_from_date: {
              ...enrollmentDetailsFormState.effective_from_date,
              isDisable: false,
              value: getEntrollmentDate,
            }
          }))
          setFormData2((facility_enrollmentdetails: { effective_from_date: any }) => ({
            ...facility_enrollmentdetails,
            effective_from_date: {
              ...facility_enrollmentdetails.effective_from_date,
              '#minDate': dayjs(getEntrollmentDate).format('YYYY-MM-DD')
            }
          }

          ))
        }
        else {
          setEnrollmentDetailsFormState((enrollmentDetailsFormState: any) => ({
            ...enrollmentDetailsFormState,
            effective_from_date: {
              ...enrollmentDetailsFormState.effective_from_date,
              isDisable: false,
              value: '',
            }
          }))
          setFormData2((facility_enrollmentdetails: { effective_from_date: any }) => ({
            ...facility_enrollmentdetails,
            effective_from_date: {
              ...facility_enrollmentdetails.effective_from_date,
              '#minDate': oneYearAgoDate,
            }
          }

          ))
        }
      }
      catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }
    }
    effectiveFromDate();

  }
    , [enrollmentDetailsFormState.date_of_enrollment.value]);

  /*Get Facility Status */

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const facility_status = await axios.getWithCache(`${endpoints.getFacilityStatus}`, Auth.loggedIn());
        const facilityStatus_options = facility_status.data.data.filter((key: any) => key?.status !== "Permanently Closed").map((key: any) => (
          {
            value: key?.status,
            label: key?.status,
            id: key?.satus_id
          }
        ));

        if (facilityDetailsFormState?.hpr_id?.value) {
          const updatedOptions = facilityStatus_options.filter((option: any) => option.value !== 'Inactive');
          setFormData2((facility_enrollmentdetails: { status: any }) => ({
            ...facility_enrollmentdetails,
            status: {
              ...facility_enrollmentdetails.status,
              '#options': updatedOptions,
              '#isDisabled': false,
            }
          }

          ))
          setEnrollmentDetailsFormState((enrollmentDetailsFormState: any) => ({
            ...enrollmentDetailsFormState,
            status: {
              ...enrollmentDetailsFormState.state,
              isDisable: false,
              value: '',
              label: '',
              id: '',
            }
          }))
        }
        else {
          setFormData2((facility_enrollmentdetails: { status: any }) => ({
            ...facility_enrollmentdetails,
            status: {
              ...facility_enrollmentdetails.status,
              '#options': [],
              '#isDisabled': true,
            }
          }))
          setEnrollmentDetailsFormState((enrollmentDetailsFormState: any) => ({
            ...enrollmentDetailsFormState,
            status: {
              ...enrollmentDetailsFormState.status,
              isDisable: true,
              value: 'Inactive',
              id: 'd1b444b2-7735-4a35-8ba1-b8fbed0a0810',
            }
          }))
        }
      }
      catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }
    }
    fetchStatus();
  }, [facilityDetailsFormState?.hpr_id?.value])

  /* Hiherarchy Details  URBAN*/
  /*Get States-URBAN*/
  const [formData3_1, setFormData3_1] = useState<any>(hierarchy_details_urban);

  /* Get ULB ,Sub-Dist ,HealthBlock,sub-division by district ID -URBAN*/

  useEffect(() => {
    const fetchStateUrban = async () => {
      if (hierarchyDetailsUrbanFormState) {
        try {
          const getState = await axios.getWithCache(`${endpoints.getStates}`, Auth.loggedIn());

          setFormData3_1((hierarchy_details_urban: any) => ({
            ...hierarchy_details_urban,
            state: {
              ...hierarchy_details_urban.state,
              '#options': getState.data.data,
              '#isDisabled': (!facilityDetailsFormState.hpr_id.value) ? (getState.data.data.length === 1 ? true : false) : true,
            },
            sub_district: {
              ...hierarchy_details_urban.sub_district,
              '#options': [],
              '#isDisabled':(facilityDetailsFormState.hpr_id.value && hierarchyDetailsUrbanFormState.sub_district.value)? true : false,
            },
            health_block: {
              ...hierarchy_details_urban.health_block,
              '#options': [],
            },
            sub_division: {
              ...hierarchy_details_urban.sub_division,
              '#options': [],
            },
            ward: {
              ...hierarchy_details_urban.ward,
              '#options': [],
              '#required': false
            },
            lac: {
              ...hierarchy_details_urban.lac,
              '#options': [],
            },
          }));
          setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
            ...hierarchyDetailsUrbanFormState,
            state: {
              ...hierarchyDetailsUrbanFormState.state,
              value: getState.data.data.length === 1 ? `${getState.data.data[0].state_name}-${getState.data.data[0].state_code}` : hierarchyDetailsUrbanFormState.state.value,
              id: getState.data.data.length === 1 ? getState.data.data[0].state_id :hierarchyDetailsUrbanFormState.state.id,
              code: getState.data.data.length === 1 ? getState.data.data[0].state_code :hierarchyDetailsUrbanFormState.state.code,
            },
            district: {
              ...hierarchyDetailsUrbanFormState.district,
              value: !facilityDetailsFormState.hpr_id.value ? '' : hierarchyDetailsUrbanFormState.district.value,
              id: !facilityDetailsFormState.hpr_id.value ? '' : hierarchyDetailsUrbanFormState.district.id,
              code: !facilityDetailsFormState.hpr_id.value ? '' : hierarchyDetailsUrbanFormState.district.code,
            },
            ulb: {
              ...hierarchyDetailsUrbanFormState.ulb,
              value: '',
              id: '',
            },
            sub_district: {
              ...hierarchyDetailsUrbanFormState.sub_district,
              value: !facilityDetailsFormState.hpr_id.value ? '' : hierarchyDetailsUrbanFormState.sub_district.value,
              id: !facilityDetailsFormState.hpr_id.value ? '' : hierarchyDetailsUrbanFormState.sub_district.id,
              code: !facilityDetailsFormState.hpr_id.value ? '' : hierarchyDetailsUrbanFormState.sub_district.code
            },
            health_block: {
              ...hierarchyDetailsUrbanFormState.health_block,
              value: '',
              id: '',
            },
            sub_division: {
              ...hierarchyDetailsUrbanFormState.sub_division,
              value: '',
              id: '',
            },
            ward: {
              ...hierarchyDetailsUrbanFormState.ward,
              value: '',
              id: '',
            },
            parlimentary: {
              ...hierarchyDetailsUrbanFormState.parlimentary,
              value: '',
              id: '',
            },
            lac: {
              ...hierarchyDetailsUrbanFormState.lac,
              value: '',
              id: '',
            },
          }));
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
      }
      else {
        setFormData3_1((hierarchy_details_urban: any) => ({
          ...hierarchy_details_urban,
          state: {
            ...hierarchy_details_urban.state,
            '#options': [],
            '#isDisabled': false,
          },
          district: {
            ...hierarchy_details_urban.district,
            '#options': [],
            '#isDisabled': false,
          },
          sub_district: {
            ...hierarchy_details_urban.sub_district,
            '#options': [],
            '#isDisabled': false,
          },
          ulb: {
            ...hierarchy_details_urban.ulb,
            '#options': [],
          },
          parlimentary: {
            ...hierarchy_details_urban.parlimentary,
            '#options': [],
          },
        }));
      }
    }
    fetchStateUrban();

  }, []);

  const fecthUlbBySearch = async (ulbInputText:string) => {
    const getUlbwithsearch = await axios.get(`${endpoints.fetchUlbByStateIdAndSearch(hierarchyDetailsUrbanFormState?.state?.id, ulbInputText)}`, Auth.loggedIn());
    const getUlb_options = getUlbwithsearch?.data.data?.map((key: any) => ({
      value: `${key.ulb_name}-${key.ulb_code}`,
      label: `${key.ulb_name}-${key.ulb_code}`,
      id: key.ulb_id,
      code: key.ulb_code,
    }));
    setFormData3_1((hierarchy_details_urban: any) => ({
      ...hierarchy_details_urban,
      ulb: {
        ...hierarchy_details_urban.ulb,
        '#options': getUlb_options,
        '#required': true,
        '#isDisabled': false,
      },
    }));
  }

  useEffect(()=>{
    if(hierarchyDetailsUrbanFormState?.state?.id && ulbInputText?.length >= 3){
      fecthUlbBySearch(ulbInputText)
    }
    if(ulbInputText?.length === 0)
    {
      setFormData3_1((hierarchy_details_urban: any) => ({
        ...hierarchy_details_urban,
        ulb: {
          ...hierarchy_details_urban.ulb,
          '#options': [],
        },
      }));
    }
  },[ulbInputText])

  useEffect(() => {
    const fetchDistrictandULBUrban = async () => {
      if (hierarchyDetailsUrbanFormState?.state?.id) {
        await checkIfUsingGramPanchayatCoverage();
        setCoverageDetailsFormState((coverageDetailsFormState: any) => ({
          ...coverageDetailsFormState,
          wards_covered: {
            ...coverageDetailsFormState.wards_covered,
            value: [],
            id: [],
            code: [],
            isError: false,
          },
          villages_covered: {
            ...coverageDetailsFormState.villages_covered,
            value: [],
            id: [],
            code: [],
            isError: false,
          },
          gram_panchayat_covered: {
            ...coverageDetailsFormState.gram_panchayat_covered,
            value: [],
            id: [],
            code: [],
            isError: false,
          },
        }));
        try {
          const getDistrict = await axios.getWithCache(`${endpoints.getDistricts(hierarchyDetailsUrbanFormState.state.id)}`, Auth.loggedIn());

          setFormData3_1((hierarchy_details_urban: any) => ({
            ...hierarchy_details_urban,
            district: {
              ...hierarchy_details_urban.district,
              '#options': getDistrict.data.data,
              '#isDisabled': (!facilityDetailsFormState.hpr_id.value) ? (getDistrict.data.data.length === 1 ? true :false) : true,
            },
            sub_district: {
              ...hierarchy_details_urban.sub_district,
              '#options': [],
              '#isDisabled':(facilityDetailsFormState.hpr_id.value && hierarchyDetailsUrbanFormState.sub_district.value) ? true : false,
            },
            health_block: {
              ...hierarchy_details_urban.health_block,
              '#options': [],
            },
            sub_division: {
              ...hierarchy_details_urban.sub_division,
              '#options': [],
            },
            ward: {
              ...hierarchy_details_urban.ward,
              '#options': [],
            },
            lac: {
              ...hierarchy_details_urban.lac,
              '#options': [],
            },
          }));
          setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
            ...hierarchyDetailsUrbanFormState,
            district: {
              ...hierarchyDetailsUrbanFormState.district,
              value: !facilityDetailsFormState.hpr_id.value ? (getDistrict.data.data.length=== 1? `${getDistrict.data.data[0].district_name}-${getDistrict.data.data[0].district_code}` :'') : hierarchyDetailsUrbanFormState.district.value,
              id: !facilityDetailsFormState.hpr_id.value ? (getDistrict.data.data.length=== 1? `${getDistrict.data.data[0].district_id}` :'') : hierarchyDetailsUrbanFormState.district.id,
              code: !facilityDetailsFormState.hpr_id.value ? (getDistrict.data.data.length=== 1? `${getDistrict.data.data[0].district_code}` :'') : hierarchyDetailsUrbanFormState.district.code,
            },
            sub_district: {
              ...hierarchyDetailsUrbanFormState.sub_district,
              value: !facilityDetailsFormState.hpr_id.value ? '': hierarchyDetailsUrbanFormState.sub_district.value,
              id: !facilityDetailsFormState.hpr_id.value ? '': hierarchyDetailsUrbanFormState.sub_district.id,
              code: !facilityDetailsFormState.hpr_id.value ? '': hierarchyDetailsUrbanFormState.sub_district.code,
            },
            health_block: {
              ...hierarchyDetailsUrbanFormState.health_block,
              value: '',
              id: '',
            },
            sub_division: {
              ...hierarchyDetailsUrbanFormState.sub_division,
              value: '',
              id: '',
            },
            ward: {
              ...hierarchyDetailsUrbanFormState.ward,
              value: '',
              id: '',
            },
            parlimentary: {
              ...hierarchyDetailsUrbanFormState.parlimentary,
              value: '',
              id: '',
            },
            lac: {
              ...hierarchyDetailsUrbanFormState.lac,
              value: '',
              id: '',
            },
          }));
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
      }
      else {
        setFormData3_1((hierarchy_details_urban: any) => ({
          ...hierarchy_details_urban,
          district: {
            ...hierarchy_details_urban.district,
            '#options': [],
            '#isDisabled': false,
          },
          sub_district: {
            ...hierarchy_details_urban.sub_district,
            '#options': [],
            '#isDisabled': false,
          },
          ulb: {
            ...hierarchy_details_urban.ulb,
            '#options': [],
          },
          health_block: {
            ...hierarchy_details_urban.health_block,
            '#options': [],
          },
          sub_division: {
            ...hierarchy_details_urban.sub_division,
            '#options': [],
          },
          ward: {
            ...hierarchy_details_urban.ward,
            '#options': [],
          },
          parlimentary: {
            ...hierarchy_details_urban.parlimentary,
            '#options': [],
          },
          lac: {
            ...hierarchy_details_urban.lac,
            '#options': [],
          },
        }));
        setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
          ...hierarchyDetailsUrbanFormState,
          district: {
            ...hierarchyDetailsUrbanFormState.district,
            value: '',
            id: '',
            code: '',
          },
          sub_district: {
            ...hierarchyDetailsUrbanFormState.sub_district,
            value: '',
            id: '',
          },
          ulb: {
            ...hierarchyDetailsUrbanFormState.ulb,
            value: '',
            id: '',
          },
          health_block: {
            ...hierarchyDetailsUrbanFormState.health_block,
            value: '',
            id: '',
          },
          sub_division: {
            ...hierarchyDetailsUrbanFormState.sub_division,
            value: '',
            id: '',
          },
          ward: {
            ...hierarchyDetailsUrbanFormState.ward,
            value: '',
            id: '',
          },
          parlimentary: {
            ...hierarchyDetailsUrbanFormState.parlimentary,
            value: '',
            id: '',
          },
          lac: {
            ...hierarchyDetailsUrbanFormState.lac,
            value: '',
            id: '',
          },
        }));
      }
    }
    fetchDistrictandULBUrban();

  }, [hierarchyDetailsUrbanFormState?.state?.id]);



  useEffect(() => {
    const fetchSubDistHealthBlandSubDiv = async () => {
      if (hierarchyDetailsUrbanFormState?.district?.id) {
        try {
          const getSubDist = await axios.getWithCache(`${endpoints.getSubDistricts(hierarchyDetailsUrbanFormState.district.id)}`, Auth.loggedIn());
          const getHealthBlock = await axios.getWithCache(`${endpoints.getHealthBlock(hierarchyDetailsUrbanFormState.district.id)}`, Auth.loggedIn());
          const subDivision = await axios.getWithCache(`${endpoints.getSubDivision(hierarchyDetailsUrbanFormState.district.id)}`, Auth.loggedIn());

          setFormData3_1((hierarchy_details_urban: { ulb: any, sub_district: any, health_block: any, sub_division: any }) => ({
            ...hierarchy_details_urban,
            sub_district: {
              ...hierarchy_details_urban.sub_district,
              '#options': getSubDist.data.data,
              '#required': getSubDist.data.meta.numberOfRecords > 0 ? true : false,
              '#isDisabled':(facilityDetailsFormState.hpr_id.value && hierarchyDetailsUrbanFormState.sub_district.value) ? true : false,
            },
            health_block: {
              ...hierarchy_details_urban.health_block,
              '#options': getHealthBlock.data.data,
            },
            sub_division: {
              ...hierarchy_details_urban.sub_division,
              '#options': subDivision.data.data,
            }
          }));
          setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
            ...hierarchyDetailsUrbanFormState,
            sub_district: {
              ...hierarchyDetailsUrbanFormState.sub_district,
              value: !facilityDetailsFormState.hpr_id.value ? '': hierarchyDetailsUrbanFormState.sub_district.value,
              id: !facilityDetailsFormState.hpr_id.value ? '': hierarchyDetailsUrbanFormState.sub_district.id,
              code: !facilityDetailsFormState.hpr_id.value ? '': hierarchyDetailsUrbanFormState.sub_district.code,
            },
            health_block: {
              ...hierarchyDetailsUrbanFormState.health_block,
              value: '',
              id: '',
            },
            sub_division: {
              ...hierarchyDetailsUrbanFormState.sub_division,
              value: '',
              id: '',
            },
          }));
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
      }
      else {
        setFormData3_1((hierarchy_details_urban: { ulb: any, sub_district: any, health_block: any, sub_division: any }) => ({
          ...hierarchy_details_urban,
          sub_district: {
            ...hierarchy_details_urban.sub_district,
            '#options': [],
            '#isDisabled': false,
          },
          health_block: {
            ...hierarchy_details_urban.health_block,
            '#options': [],
          },
          sub_division: {
            ...hierarchy_details_urban.sub_division,
            '#options': [],
          }
        }));
        setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
          ...hierarchyDetailsUrbanFormState,
          sub_district: {
            ...hierarchyDetailsUrbanFormState.sub_district,
            value: '',
            id: '',
          },
          health_block: {
            ...hierarchyDetailsUrbanFormState.health_block,
            value: '',
            id: '',
          },
          sub_division: {
            ...hierarchyDetailsUrbanFormState.sub_division,
            value: '',
            id: '',
          },
        }));
      }
    }
    fetchSubDistHealthBlandSubDiv();

  }, [hierarchyDetailsUrbanFormState?.district?.id]);

  useEffect(() => {
    const fetchWard = async () => {
      if (hierarchyDetailsUrbanFormState?.ulb?.id) {
        try {
          const selectedULB = hierarchyDetailsUrbanFormState?.ulb?.value;
          const getWardResponse = await axios.getWithCache(`${endpoints.getWard(hierarchyDetailsUrbanFormState?.ulb?.id)}`, Auth.loggedIn());
          const getWard_options = getWardResponse?.data.data?.map((key: any) => ({
            value: `${selectedULB} - ${key.ward_name} - ${key.ward_code}`,
            label: `${selectedULB} - ${key.ward_name} - ${key.ward_code}`,
            id: key.ward_id,
            code: key.ward_code,
          }));



          setFormData3_1((hierarchy_details_urban: { ward: any }) => ({
            ...hierarchy_details_urban,
            ward: {
              ...hierarchy_details_urban.ward,
              '#options': getWard_options,
              '#required': getWard_options.length ? true : false,
            }
          }));
          setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
            ...hierarchyDetailsUrbanFormState,
            ward: {
              ...hierarchyDetailsUrbanFormState.ward,
              value: '',
              id: '',
            },
          }));
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
      }
      else {
        setFormData3_1((hierarchy_details_urban: { ward: any }) => ({
          ...hierarchy_details_urban,
          ward: {
            ...hierarchy_details_urban.ward,
            '#options': [],
            '#required': false,
          }
        }));
        setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
          ...hierarchyDetailsUrbanFormState,
          ward: {
            ...hierarchyDetailsUrbanFormState.ward,
            value: '',
            id: '',
            isError: false,
            message: '',
          },
        }));
      }
    }
    fetchWard();
  }, [hierarchyDetailsUrbanFormState?.ulb?.id])

  useEffect(() => {
    const fetchPac = async () => {
      if (hierarchyDetailsUrbanFormState?.state?.id) {
        try {
          const getPac = await axios.getWithCache(`${endpoints.getPacByStateId(hierarchyDetailsUrbanFormState.state.id)}`, Auth.loggedIn());

          const getPac_options = getPac?.data.data?.map((key: any) => ({
            value: `${key.pc_name}-${key.pc_code}`,
            label: `${key.pc_name}-${key.pc_code}`,
            id: key.pc_id,
            code: key.pc_code,
          }));
          setFormData3_1((hierarchy_details_urban: any) => ({
            ...hierarchy_details_urban,
            parlimentary: {
              ...hierarchy_details_urban.parlimentary,
              '#options': getPac_options
            },
            lac: {
              ...hierarchy_details_urban.lac,
              '#options': [],
            }
          }));
          setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
            ...hierarchyDetailsUrbanFormState,
            lac: {
              ...hierarchyDetailsUrbanFormState.lac,
              value: '',
              id: '',
            },
          }));
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
      }
      else {
        setFormData3_1((hierarchy_details_urban: any) => ({
          ...hierarchy_details_urban,
          parlimentary: {
            ...hierarchy_details_urban.parlimentary,
            '#options': [],
          },
          lac: {
            ...hierarchy_details_urban.lac,
            '#options': [],
          }
        }));
        setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
          ...hierarchyDetailsUrbanFormState,
          parlimentary: {
            ...hierarchyDetailsUrbanFormState.parlimentary,
            value: '',
            id: '',
          },
          lac: {
            ...hierarchyDetailsUrbanFormState.lac,
            value: '',
            id: '',
          },
        }));
      }
    }
    fetchPac();
  }, [hierarchyDetailsUrbanFormState?.state?.id]);


  useEffect(() => {
    const fetchLac = async () => {
      if (hierarchyDetailsUrbanFormState?.parlimentary?.id) {
        try {
          const getLac = await axios.getWithCache(`${endpoints.getLacByPac(hierarchyDetailsUrbanFormState.parlimentary.id)}`, Auth.loggedIn());
          setFormData3_1((hierarchy_details_urban: { lac: any }) => ({
            ...hierarchy_details_urban,
            lac: {
              ...hierarchy_details_urban.lac,
              '#options': getLac.data.data,
            }
          }));
          setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
            ...hierarchyDetailsUrbanFormState,
            lac: {
              ...hierarchyDetailsUrbanFormState.lac,
              value: '',
              id: '',
            },
          }));
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
      }
      else {
        setFormData3_1((hierarchy_details_urban: { lac: any }) => ({
          ...hierarchy_details_urban,
          lac: {
            ...hierarchy_details_urban.lac,
            '#options': [],
          },
        }));
        setHierarchyDetailsUrbanFormState((hierarchyDetailsUrbanFormState: any) => ({
          ...hierarchyDetailsUrbanFormState,
          lac: {
            ...hierarchyDetailsUrbanFormState.lac,
            value: '',
            id: '',
          },
        }));
      }
    }
    fetchLac();
  }, [hierarchyDetailsUrbanFormState?.parlimentary?.id])

 

  useEffect(() => {
    const fetchStateRural = async () => {
      if (hierarchyDetailsRuralFormState) {
        try {
          checkIfUsingGramPanchayat();
          const getState = await axios.getWithCache(`${endpoints.getStates}`, Auth.loggedIn());

          setFormData3_2((hierarchy_details_rural: any) => ({
            ...hierarchy_details_rural,
            state: {
              ...hierarchy_details_rural.state,
              '#options': getState.data.data,
              '#isDisabled': (!facilityDetailsFormState.hpr_id.value)? (getState.data.data.length === 1 ? true : false) : true,
            },
            district: {
              ...hierarchy_details_rural.district,
              '#isDisabled': !facilityDetailsFormState.hpr_id.value ? false : true,
            },
            sub_district: {
              ...hierarchy_details_rural.sub_district,
              '#options': [],
              '#isDisabled':(facilityDetailsFormState.hpr_id.value && hierarchyDetailsRuralFormState.sub_district.value) ? true : false,
            },
            block: {
              ...hierarchy_details_rural.block,
              '#options': [],
            },
            health_block: {
              ...hierarchy_details_rural.health_block,
              '#options': [],
            },
            sub_division: {
              ...hierarchy_details_rural.sub_division,
              '#options': [],
            },
            village: {
              ...hierarchy_details_rural.village,
              '#options': [],
              '#required': false,
            },
            gram_panchayat: {
              ...hierarchy_details_rural.gram_panchayat,
              '#options': [],
              '#required': false,
            },
            lac: {
              ...hierarchy_details_rural.lac,
              '#options': [],
            },
          }));
          setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
            ...hierarchyDetailsRuralFormState,
            state: {
              ...hierarchyDetailsRuralFormState.state,
              value: getState.data.data.length===1 ?`${getState.data.data[0].state_name}-${getState.data.data[0].state_code}` :hierarchyDetailsRuralFormState.state.value,
              id: getState.data.data.length===1 ? `${getState.data.data[0].state_id}` :hierarchyDetailsRuralFormState.state.id,
              code: getState.data.data.length===1 ? `${getState.data.data[0].state_code}`:hierarchyDetailsRuralFormState.state.code,
            },
            district: {
              ...hierarchyDetailsRuralFormState.district,
              value: !facilityDetailsFormState.hpr_id.value ? '' : hierarchyDetailsRuralFormState.district.value,
              id: !facilityDetailsFormState.hpr_id.value ? '' : hierarchyDetailsRuralFormState.district.id,
              code: !facilityDetailsFormState.hpr_id.value ? '' : hierarchyDetailsRuralFormState.district.code,
            },
            sub_district: {
              ...hierarchyDetailsRuralFormState.sub_district,
              value: !facilityDetailsFormState.hpr_id.value ? '' : hierarchyDetailsRuralFormState.sub_district.value,
              id: !facilityDetailsFormState.hpr_id.value ? '' : hierarchyDetailsRuralFormState.sub_district.id,
              code:!facilityDetailsFormState.hpr_id.value ? '' : hierarchyDetailsRuralFormState.sub_district.code,
            },
            block: {
              ...hierarchyDetailsRuralFormState.block,
              value: '',
              id: '',
            },
            health_block: {
              ...hierarchyDetailsRuralFormState.health_block,
              value: '',
              id: '',
            },
            sub_division: {
              ...hierarchyDetailsRuralFormState.sub_division,
              value: '',
              id: '',
            },
            village: {
              ...hierarchyDetailsRuralFormState.village,
              value: '',
              id: '',
            },
            gram_panchayat: {
              ...hierarchyDetailsRuralFormState.gram_panchayat,
              value: '',
              id: '',
            },
            parlimentary: {
              ...hierarchyDetailsRuralFormState.parlimentary,
              value: '',
              id: '',
            },
            lac: {
              ...hierarchyDetailsRuralFormState.lac,
              value: '',
              id: '',
            },
          }));
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
      }
      else {
        setFormData3_2((hierarchy_details_rural: any) => ({
          ...hierarchy_details_rural,
          state: {
            ...hierarchy_details_rural.state,
            '#options': [],
            '#isDisabled': false,
          },
          district: {
            ...hierarchy_details_rural.district,
            '#options': [],
            '#isDisabled': false,
          },
          sub_district: {
            ...hierarchy_details_rural.district,
            '#options': [],
            '#isDisabled': false,
          },
          parlimentary: {
            ...hierarchy_details_rural.parlimentary,
            '#options': [],
          },
        }));
      }
    }
    fetchStateRural();

  }, []);

  useEffect(() => {
    const fetchDistrictRural = async () => {
      if (hierarchyDetailsRuralFormState?.state?.id) {
        try {
          checkIfUsingGramPanchayat();
          const getDistrict = await axios.getWithCache(`${endpoints.getDistricts(hierarchyDetailsRuralFormState.state.id)}`, Auth.loggedIn());
          setFormData3_2((hierarchy_details_rural: any) => ({
            ...hierarchy_details_rural,
            district: {
              ...hierarchy_details_rural.district,
              '#options': getDistrict.data.data,
              '#isDisabled':(!facilityDetailsFormState.hpr_id.value) ? (getDistrict.data.data.length === 1? true : false) : true,
            },
            sub_district: {
              ...hierarchy_details_rural.sub_district,
              '#options': [],
              '#isDisabled':(facilityDetailsFormState.hpr_id.value && hierarchyDetailsRuralFormState.sub_district.value) ? true : false,
            },
            // block: {
            //   ...hierarchy_details_rural.block,
            //   '#options': [],
            // },
            health_block: {
              ...hierarchy_details_rural.health_block,
              '#options': [],
            },
            sub_division: {
              ...hierarchy_details_rural.sub_division,
              '#options': [],
            },
            village: {
              ...hierarchy_details_rural.village,
              '#options': [],
            },
            gram_panchayat: {
              ...hierarchy_details_rural.gram_panchayat,
              '#options': [],
            },
            lac: {
              ...hierarchy_details_rural.lac,
              '#options': [],
            },
          }));
          setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
            ...hierarchyDetailsRuralFormState,
            district: {
              ...hierarchyDetailsRuralFormState.district,
              value: !facilityDetailsFormState.hpr_id.value ? (getDistrict.data.data.length === 1?`${getDistrict.data.data[0].district_name}-${getDistrict.data.data[0].district_code}`:'') : hierarchyDetailsRuralFormState.district.value,
              id: !facilityDetailsFormState.hpr_id.value ? (getDistrict.data.data.length === 1?`${getDistrict.data.data[0].district_id}`:'') : hierarchyDetailsRuralFormState.district.id,
              code: !facilityDetailsFormState.hpr_id.value ? (getDistrict.data.data.length === 1?`${getDistrict.data.data[0].district_code}`:'') : hierarchyDetailsRuralFormState.district.code,
            },
            sub_district: {
              ...hierarchyDetailsRuralFormState.sub_district,
              value: !facilityDetailsFormState.hpr_id.value ? '' : hierarchyDetailsRuralFormState.sub_district.value,
              id: !facilityDetailsFormState.hpr_id.value ? '' : hierarchyDetailsRuralFormState.sub_district.id,
              code: !facilityDetailsFormState.hpr_id.value ? '' : hierarchyDetailsRuralFormState.sub_district.code,
            },
            block: {
              ...hierarchyDetailsRuralFormState.block,
              value: '',
              id: '',
            },
            health_block: {
              ...hierarchyDetailsRuralFormState.health_block,
              value: '',
              id: '',
            },
            sub_division: {
              ...hierarchyDetailsRuralFormState.sub_division,
              value: '',
              id: '',
            },
            village: {
              ...hierarchyDetailsRuralFormState.village,
              value: '',
              id: '',
            },
            gram_panchayat: {
              ...hierarchyDetailsRuralFormState.gram_panchayat,
              value: '',
              id: '',
            },
            parlimentary: {
              ...hierarchyDetailsRuralFormState.parlimentary,
              value: '',
              id: '',
            },
            lac: {
              ...hierarchyDetailsRuralFormState.lac,
              value: '',
              id: '',
            },
          }));
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
      }
      else {
        setFormData3_2((hierarchy_details_rural: any) => ({
          ...hierarchy_details_rural,
          district: {
            ...hierarchy_details_rural.district,
            '#options': [],
            '#isDisabled': false,
          },
          sub_district: {
            ...hierarchy_details_rural.sub_district,
            '#options': [],
            '#isDisabled': false,
          },
          block: {
            ...hierarchy_details_rural.block,
            '#options': [],
          },
          health_block: {
            ...hierarchy_details_rural.health_block,
            '#options': [],
          },
          sub_division: {
            ...hierarchy_details_rural.sub_division,
            '#options': [],
          },
          village: {
            ...hierarchy_details_rural.village,
            '#options': [],
          },
          gram_panchayat: {
            ...hierarchy_details_rural.gram_panchayat,
            '#options': [],
          },
          lac: {
            ...hierarchy_details_rural.lac,
            '#options': [],
          }
        }));
        setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
          ...hierarchyDetailsRuralFormState,
          district: {
            ...hierarchyDetailsRuralFormState.district,
            value: '',
            id: '',
            code: '',
          },
          sub_district: {
            ...hierarchyDetailsRuralFormState.sub_district,
            value: '',
            id: '',
          },
          block: {
            ...hierarchyDetailsRuralFormState.block,
            value: '',
            id: '',
          },
          health_block: {
            ...hierarchyDetailsRuralFormState.health_block,
            value: '',
            id: '',
          },
          sub_division: {
            ...hierarchyDetailsRuralFormState.sub_division,
            value: '',
            id: '',
          },
          village: {
            ...hierarchyDetailsRuralFormState.village,
            value: '',
            id: '',
          },
          gram_panchayat: {
            ...hierarchyDetailsRuralFormState.gram_panchayat,
            value: '',
            id: '',
          },
          parlimentary: {
            ...hierarchyDetailsRuralFormState.parlimentary,
            value: '',
            id: '',
          },
          lac: {
            ...hierarchyDetailsRuralFormState.lac,
            value: '',
            id: '',
          },
        }));
      }
    }
    fetchDistrictRural();

  }, [hierarchyDetailsRuralFormState?.state?.id]);

  /* Get Block ,Sub-Dist ,HealthBlock,sub-division by district ID -Rural*/
  useEffect(() => {
    const fetchBlock = async () => {
      if (hierarchyDetailsRuralFormState?.district?.id) {
        try {
          const getBlock = await axios.getWithCache(`${endpoints.getBlock(hierarchyDetailsRuralFormState.district.id)}`, Auth.loggedIn());
          setFormData3_2((hierarchy_details_rural: { block: any }) => ({
            ...hierarchy_details_rural,
            block: {
              ...hierarchy_details_rural.block,
              '#options': getBlock.data.data,
              '#required': getBlock.data.meta.numberOfRecords > 0 ? true : false,
            },
          }));
          setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
            ...hierarchyDetailsRuralFormState,
            block: {
              ...hierarchyDetailsRuralFormState.block,
              value: '',
              id: '',
            },
            village: {
              ...hierarchyDetailsRuralFormState.village,
              value: '',
              id: '',
            },
            gram_panchayat: {
              ...hierarchyDetailsRuralFormState.gram_panchayat,
              value: '',
              id: '',
            },
          }));
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
      }
      else {
        setFormData3_2((hierarchy_details_rural: any) => ({
          ...hierarchy_details_rural,
          block: {
            ...hierarchy_details_rural.block,
            '#options': [],
          },
          village: {
            ...hierarchy_details_rural.village,
            '#options': [],
          },
          gram_panchayat: {
            ...hierarchy_details_rural.gram_panchayat,
            '#options': [],
          },
        }));
        setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
          ...hierarchyDetailsRuralFormState,
          block: {
            ...hierarchyDetailsRuralFormState.block,
            value: '',
            id: '',
          },
          village: {
            ...hierarchyDetailsRuralFormState.village,
            value: '',
            id: '',
          },
          gram_panchayat: {
            ...hierarchyDetailsRuralFormState.gram_panchayat,
            value: '',
            id: '',
          },
        }));
      }
    }
    fetchBlock();

  }, [hierarchyDetailsRuralFormState?.district?.id]);

  useEffect(() => {
    const fetchSubDistHealthBlandSubDiv = async () => {
      if (hierarchyDetailsRuralFormState?.district?.id) {
        try {
          // const getBlock = await axios.get(`${endpoints.getBlock}/${hierarchyDetailsRuralFormState.district.id}`);
          const getSubDist = await axios.getWithCache(`${endpoints.getSubDistricts(hierarchyDetailsRuralFormState.district.id)}`, Auth.loggedIn());
          const getHealthBlock = await axios.getWithCache(`${endpoints.getHealthBlock(hierarchyDetailsRuralFormState.district.id)}`, Auth.loggedIn());
          const subDivision = await axios.getWithCache(`${endpoints.getSubDivision(hierarchyDetailsRuralFormState.district.id)}`, Auth.loggedIn());
          setFormData3_2((hierarchy_details_rural: { block: any, sub_district: any, health_block: any, sub_division: any }) => ({
            ...hierarchy_details_rural,
            sub_district: {
              ...hierarchy_details_rural.sub_district,
              '#options': getSubDist.data.data,
              '#required': getSubDist.data.meta.numberOfRecords > 0 ? true : false,
              '#isDisabled':(facilityDetailsFormState.hpr_id.value && hierarchyDetailsRuralFormState.sub_district.value) ? true : false,
            },
            health_block: {
              ...hierarchy_details_rural.health_block,
              '#options': getHealthBlock.data.data,
            },
            sub_division: {
              ...hierarchy_details_rural.sub_division,
              '#options': subDivision.data.data,
            }
          }));
          setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
            ...hierarchyDetailsRuralFormState,
            sub_district: {
              ...hierarchyDetailsRuralFormState.sub_district,
              value: !facilityDetailsFormState.hpr_id.value ? '' : hierarchyDetailsRuralFormState.sub_district.value,
              id: !facilityDetailsFormState.hpr_id.value ? '' : hierarchyDetailsRuralFormState.sub_district.id,
              code: !facilityDetailsFormState.hpr_id.value ? '' : hierarchyDetailsRuralFormState.sub_district.code,
            },
            health_block: {
              ...hierarchyDetailsRuralFormState.health_block,
              value: '',
              id: '',
            },
            sub_division: {
              ...hierarchyDetailsRuralFormState.sub_division,
              value: '',
              id: '',
            },
          }));


        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
      }
      else {
        setFormData3_2((hierarchy_details_rural: { block: any, sub_district: any, health_block: any, sub_division: any }) => ({
          ...hierarchy_details_rural,
          sub_district: {
            ...hierarchy_details_rural.sub_district,
            '#options': [],
            '#isDisabled': false,
          },
          health_block: {
            ...hierarchy_details_rural.health_block,
            '#options': [],
          },
          sub_division: {
            ...hierarchy_details_rural.sub_division,
            '#options': [],
          }
        }));
        setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
          ...hierarchyDetailsRuralFormState,
          sub_district: {
            ...hierarchyDetailsRuralFormState.sub_district,
            value: '',
            id: '',
          },
          health_block: {
            ...hierarchyDetailsRuralFormState.health_block,
            value: '',
            id: '',
          },
          sub_division: {
            ...hierarchyDetailsRuralFormState.sub_division,
            value: '',
            id: '',
          },
        }));
      }
    }
    fetchSubDistHealthBlandSubDiv();

  }, [hierarchyDetailsRuralFormState?.district?.id]);
  const getVillage=async (blockId:any)=>{
    try {
      if (blockId) {
        const postData = {
          p_state_id: hierarchyDetailsRuralFormState?.state?.id,
          p_dist_id: hierarchyDetailsRuralFormState?.district?.id,
          p_sub_dist_ids: hierarchyDetailsRuralFormState?.sub_district?.id ? [hierarchyDetailsRuralFormState?.sub_district?.id] : [],
          p_block_ids: [blockId],
          p_hbsd_ids: [],
        }
        setVillagesPayLoad({
          "blockId": blockId,
          'healthBlockId': '',
          'subDivisionId': '',
        });
      const getVillage = await axios.post(`${endpoints.getVillagesByStateDistSubDisBlockId}`, postData, Auth.loggedInWithJSON());
      setFormData3_2((hierarchy_details_rural: { village: any }) => ({
        ...hierarchy_details_rural,
        village: {
          ...hierarchy_details_rural.village,
          '#options': getVillage.data.data,
          '#required': getVillage.data.meta.numberOfRecords > 0 ? true : false,
        },
      }));
        setVillagesCount(getVillage.data.meta.numberOfRecords);
        setHBSDSelected(false);
        const healthBlockId = hierarchyDetailsRuralFormState?.health_block?.id;
        const subDivisionId = hierarchyDetailsRuralFormState?.sub_division?.id;
        if (blockId && !healthBlockId && !subDivisionId) {
          setFormData5((coverage_details_rural: { villages_covered: any }) => ({
            ...coverage_details_rural,
            villages_covered: {
              ...coverage_details_rural.villages_covered,
              '#options': getVillage?.data?.data,
            }
          }));
        }

      setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
        ...hierarchyDetailsRuralFormState,
        village: {
          ...hierarchyDetailsRuralFormState.village,
          value: '',
          id: '',
          code:''
        },
        gram_panchayat: {
          ...hierarchyDetailsRuralFormState.gram_panchayat,
          value: '',
          id: '',
          code:''
        },
      }));
      } 
    }
      catch(error:any){
         errorLogger(error?.response?.data||error?.response||error)
      }
  }
  const getGramPanchayat=async (blockId:any)=>{
    try{
      if (blockId) {
        const postData = {
          p_state_id: hierarchyDetailsRuralFormState?.state?.id,
          p_dist_id: hierarchyDetailsRuralFormState?.district?.id,
          p_sub_dist_ids: hierarchyDetailsRuralFormState?.sub_district?.id ? [hierarchyDetailsRuralFormState?.sub_district?.id] : [],
          p_block_ids: [blockId],
          p_hbsd_ids: [],
        }
        const gramPanchayat = await axios.post(`${endpoints.getGrampanchayatByStateDistSubDisBlockId}`, postData, Auth.loggedInWithJSON());
        const gramPanchayatOptions = gramPanchayat?.data?.data.map((option1: any) => ({
          value: `${option1.gram_panchayat_name}-${option1.gram_panchayat_code}`,
          label: `${option1.gram_panchayat_name}-${option1.gram_panchayat_code}`,
          id: option1.gram_panchayat_id,
          code: option1.gram_panchayat_code
        }));
        setFormData3_2((hierarchy_details_rural: any) => ({
          ...hierarchy_details_rural,
          gram_panchayat: {
            ...hierarchy_details_rural.gram_panchayat,
            '#options': gramPanchayatOptions,
            '#required': (gramPanchayatOptions.length && formData3_2.gram_panchayat['#isDisabled'] === false) ? true : false,
          },

        }))
        const healthBlockId = hierarchyDetailsRuralFormState?.health_block?.id;
        const subDivisionId = hierarchyDetailsRuralFormState?.sub_division?.id;
        if (blockId && !healthBlockId && !subDivisionId) {
          setFormData5((coverage_details_rural: { gram_panchayat_covered: any }) => ({
            ...coverage_details_rural,
            gram_panchayat_covered: {
              ...coverage_details_rural.gram_panchayat_covered,
              '#options': gramPanchayat?.data?.data,
            },
          }));
        }
        setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
          ...hierarchyDetailsRuralFormState,
          village: {
            ...hierarchyDetailsRuralFormState.village,
            value: '',
            id: '',
            code: ''
          },
          gram_panchayat: {
            ...hierarchyDetailsRuralFormState.gram_panchayat,
            value: '',
            id: '',
            code: ''
          },
        }))
      }
  }catch(error:any){
         errorLogger(error?.response?.data||error?.response||error)
      }
  }
  /*Get Village by Block */
  useEffect(() => {
    const fetchVillage = async () => {
      if(hierarchyDetailsRuralFormState.block?.id && (formData3_2?.sub_district['#required'] == true ?  hierarchyDetailsRuralFormState.sub_district.id : true)){
        isGrampanchayat?getGramPanchayat(hierarchyDetailsRuralFormState?.block?.id):getVillage(hierarchyDetailsRuralFormState?.block?.id);
      }
      else {
        setFormData3_2((hierarchy_details_rural: { village: any,gram_panchayat:any }) => ({
          ...hierarchy_details_rural,
          village: {
            ...hierarchy_details_rural.village,
            '#options': [],
            '#required': false,
          },
          gram_panchayat: {
            ...hierarchy_details_rural.gram_panchayat,
            '#options': [],
            '#required': false,
          },
        }));
        setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
          ...hierarchyDetailsRuralFormState,
          village: {
            ...hierarchyDetailsRuralFormState.village,
            value: '',
            id: '',
            isError: false,
            message: '',
            code:''
          },
          gram_panchayat: {
            ...hierarchyDetailsRuralFormState.gram_panchayat,
            value: '',
            id: '',
            isError: false,
            message: '',
            code:''
          },
        }));
      }
    }
    fetchVillage();
  }, [hierarchyDetailsRuralFormState?.block?.id, hierarchyDetailsRuralFormState?.sub_district?.id]);

  //fetch PAC
  useEffect(() => {
    const fetchPAC = async () => {
      if (hierarchyDetailsRuralFormState?.state?.id) {
        try {
          const getPAC = await axios.getWithCache(`${endpoints.getPacByStateId(hierarchyDetailsRuralFormState.state.id)}`, Auth.loggedIn());
          const getPac_options = getPAC?.data.data?.map((key: any) => ({
            value: `${key.pc_name}-${key.pc_code}`,
            label: `${key.pc_name}-${key.pc_code}`,
            id: key.pc_id,
            code: key.pc_code,
          }));
          setFormData3_2((hierarchy_details_rural: any) => ({
            ...hierarchy_details_rural,
            parlimentary: {
              ...hierarchy_details_rural.parlimentary,
              '#options': getPac_options,
            },
            lac: {
              ...hierarchy_details_rural.lac,
              '#options': [],
            },
          }));
          setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
            ...hierarchyDetailsRuralFormState,
            lac: {
              ...hierarchyDetailsRuralFormState.lac,
              value: '',
              id: '',
            },
          }));
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
      }
      else {
        setFormData3_2((hierarchy_details_rural: any) => ({
          ...hierarchy_details_rural,
          parlimentary: {
            ...hierarchy_details_rural.parlimentary,
            '#options': [],
          },
          lac: {
            ...hierarchy_details_rural.lac,
            '#options': [],
          },
        }));
      }
    }
    fetchPAC();

  }, [hierarchyDetailsRuralFormState?.state?.id]);

  useEffect(() => {
    const fetchLAC = async () => {
      if (hierarchyDetailsRuralFormState?.parlimentary?.id) {
        try {
          const getLAC = await axios.getWithCache(`${endpoints.getLacByPac(hierarchyDetailsRuralFormState.parlimentary.id)}`, Auth.loggedIn());
          setFormData3_2((hierarchy_details_rural: { lac: any }) => ({
            ...hierarchy_details_rural,
            lac: {
              ...hierarchy_details_rural.lac,
              '#options': getLAC.data.data,
            },
          }));
          setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
            ...hierarchyDetailsRuralFormState,
            lac: {
              ...hierarchyDetailsRuralFormState.lac,
              value: '',
              id: '',
            },
          }));
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
      }
      else {
        setFormData3_2((hierarchy_details_rural: { lac: any }) => ({
          ...hierarchy_details_rural,
          lac: {
            ...hierarchy_details_rural.lac,
            '#options': [],
          },
        }));
        setHierarchyDetailsRuralFormState((hierarchyDetailsRuralFormState: any) => ({
          ...hierarchyDetailsRuralFormState,
          lac: {
            ...hierarchyDetailsRuralFormState.lac,
            value: '',
            id: '',
          },
        }));
      }
    }
    fetchLAC();

  }, [hierarchyDetailsRuralFormState?.parlimentary?.id]);

  const handleHfrIdvalidationBeforeVerify = (state: any, key: string) => {
    setFacilityDetailsFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        ...state
      },
    }));
  }

  const handleFacilityDetailsFormChange = (value: any, key: string, id: formDataType, code?: string) => {
    setFormCompleted(Array(navItemsModal.length).fill(false));
    setFacilityDetailsFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));

    if ((key === "facility_type" && value === "AAM-SHC") || (key === "facility_type" && value === "SC - Non-functional as AAM")) {

      setFormData5((coverage_details_urban: { linked_facilities: any }) => ({
        ...coverage_details_urban,
        linked_facilities: {
          ...coverage_details_urban.linked_facilities,
          '#type': 'selectionDropdown',
          '#isDisabled': false,
        }
      }));
    }
    else if ((key === "facility_type" && value !== "AAM-SHC") || (key === "facility_type" && value !== "SC - Non-functional as AAM")) {

      setFormData5((coverage_details_urban: { linked_facilities: any }) => ({
        ...coverage_details_urban,
        linked_facilities: {
          ...coverage_details_urban.linked_facilities,
          '#type': 'selectionDropdown',
          '#isDisabled': false,
        }
      }));
    }
  };

  // Enrollment Details Form Change

  const handleEnrollmentDetailsFormChange = (value: string | boolean | any, key: string, id: formDataType,) => {
    setFormCompleted([true, false, false, false, false]);

    setEnrollmentDetailsFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        isError: false,
        message: '',
      },
    }));
    if (key === 'sanctionedbed_count' && value !== '') {
      setFormData2((enrollment_details: any) => ({
        ...enrollment_details,
        functionalbed_count: {
          ...enrollment_details.functionalbed_count,
          '#isDisabled': false,
        }
      }))
    }
    if (key === 'sanctionedbed_count' && value === '') {
      setFormData2((enrollment_details: any) => ({
        ...enrollment_details,
        functionalbed_count: {
          ...enrollment_details.functionalbed_count,
          '#isDisabled': true,
        }
      }));
      setEnrollmentDetailsFormState((prevState: any) => ({
        ...prevState,
        functionalbed_count: {
          ...prevState.functionalbed_count,
          value: '',
        },
      }));
    }

  };

  //Hierarchy Details  Form Change
  const handleHierarchyDetailsFormChange = (value: string | boolean, key: string, id: formDataType, option: formDataType, code?: number) => {
    setFormCompleted([true, true, false, false, false]);

    if (facilityDetailsFormState.rural_urban.value === 'Rural') {
      setHierarchyDetailsRuralFormState((prevState: any) => ({
        ...prevState,
        [key]: {
          ...prevState[key],
          value: value,
          id: id,
          isError: false,
          message: '',
          code: code
        },
      }));
    } else {
      setHierarchyDetailsUrbanFormState((prevState: any) => ({
        ...prevState,
        [key]: {
          ...prevState[key],
          value: value,
          id: id,
          isError: false,
          message: '',
          code: code
        },
      }));
    }
    if(key === 'state' || key === 'district')
    {
      setLocationDetailsFormState((locationDetails:any)=>({
        ...locationDetails,
        pincode:{
          ...locationDetails.pincode,
          value:''
        },
        lattitude:{
          ...locationDetails.lattitude,
          value:''
        },
        longitude:{
          ...locationDetails.longitude,
          value:''
        },
        address:{
          ...locationDetails.address,
          value:''
        },
      }));
    }
  };

  const handleInputChange=_.debounce((value:string, key:string)=>{
    if(key === 'ulb'){
      setUlbInputText(value.trim());
    }
  },500);

  //Location Details  Form Change
  const handleLocationDetailsFormChange = useCallback((value: string | boolean, key: string) => {
    setFormCompleted([true, true, true, false, false]);

    setLocationDetailsFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        isError: false,
        message: '',
      },
    }));
  }, []);
  const handleLocationDetailsError = useCallback((value: any, key: string) => {
    setLocationDetailsFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        ...value
      },
    }));
  }, []);

  const handleLocationDetailsDataChangeOnMapFails = useCallback((data: any) => {
    setLocationDetailsFormData((prevState: any) => ({
      ...prevState,
      lattitude: {
        '#type': 'textfield',
        '#title': 'Lattitude',
        '#webform_key': 'lattitude',
        '#required': true,
        '#isDisabled': data ? data : false,
      },
      longitude: {
        '#type': 'textfield',
        '#title': 'Longitude',
        '#webform_key': 'longitude',
        '#required': true,
        '#isDisabled': data ? data : false,
      },
      address: {
        '#type': 'textfield',
        '#title': 'Address',
        '#webform_key': 'address',
        '#required': true,
        '#isDisabled': data ? data : false,
      },
    }));
  }, []);

  // =====================================================

  //Coverage Details  Form Change
  const handleCoverageDetailsFormChange = (selectedValue: any, key: string, selectedItemsDetails: any) => {
    setFormCompleted([true, true, true, true, false]);
    setCoverageDetailsFormState((prevState: any) => (
      {
        ...prevState,
        [key]: {
          ...prevState[key],
          value: selectedValue,
          id: selectedItemsDetails ? selectedItemsDetails.map((item: any) => item.id) : [],
          code: selectedItemsDetails ? selectedItemsDetails.map((item: any) => item.code) : [],
          isError: false,
          message: '',
          isModalOpen: false,
        }
      }
    ))
  };

  const onDropDownClick = (key: string) => {
    setCoverageDetailsFormState((prevState: any) => (
      {
        ...prevState,
        [key]: {
          ...prevState[key],
          isModalOpen: true,
        }
      }
    ))
  }

  const handleCheckForAbdmLatLong = (facilityData: any) => {
    if (facilityData?.latitude && facilityData?.longitude) {
      return true;
    }

    return false;
  };

  const handleFacilityData = async (facilityData: any, overwriteFacilityName: boolean) => {
    setABDMdata(facilityData);

    // const updatedFacilityDetailsFormState = {
    //   ...facilityDetailsFormState,
    //   facility_name:{
    //     ...facilityDetailsFormState.facility_name,
    //     value:facilityData?.facilityName
    //   },
    // facility_type:{
    //   ...facilityDetailsFormState.facility_type,
    //   value:facilityData?.facilityType
    // },
    // ownership:{
    //   ...facilityDetailsFormState.ownership,
    //   value:facilityData?.ownership
    // },
    // }

    // const updatedEnrollmentDetailsFormState = {
    //   ...enrollmentDetailsFormState,
    //   status:{
    //     ...enrollmentDetailsFormState.status,
    //     value:facilityData?.facilityStatus
    //   },
    // }
    const updatedLocationDetailsFormState = {
      ...locationDetailsFormState,
      pincode: {
        ...locationDetailsFormState.pincode,
        value: facilityData?.pincode
      },
      lattitude: {
        ...locationDetailsFormState.lattitude,
        value: facilityData?.latitude ? Number(facilityData?.latitude).toFixed(5) : ''
      },
      longitude: {
        ...locationDetailsFormState.longitude,
        value: facilityData?.longitude ? Number(facilityData?.longitude).toFixed(5) : ''
      },
      address: {
        ...locationDetailsFormState.address,
        value: facilityData?.address
      },
    }

    const updatedFacilityDetailsFormState = { ...facilityDetailsFormState }
    if(overwriteFacilityName) {
      updatedFacilityDetailsFormState['facility_name'] = {
        ...facilityDetailsFormState.facility_name,
        value: facilityData?.facilityName,
        isError: false,
        message: '',
      }      
    }

    dispatch(setCreateMapPincodeWithHfr(
      {
        hfrVerified: true,
        pincodeWithHfr: true,
        checkDataFromAbdm: handleCheckForAbdmLatLong(facilityData)
      }
    ));

    const getState = await axios.getWithCache(`${endpoints.getStates}`, Auth.loggedIn());
    const stateSelected = getState.data.data.filter((state: any) => {
      return parseInt(state.state_code) === parseInt(facilityData.stateLGDCode)
    });
    const selectedState = stateSelected[0];

    const getDistrict = await axios.getWithCache(`${endpoints.getDistricts(stateSelected[0].state_id)}`, Auth.loggedIn());
    const districtSelected = getDistrict.data.data.filter((district: any) => {
      return parseInt(district.district_code) === parseInt(facilityData.districtLGDCode);
    });
    const selectedDistrict = districtSelected[0];

    const getSubDistrict = await axios.getWithCache(`${endpoints.getSubDistricts(districtSelected[0].district_id)}`, Auth.loggedIn());
    const subDistrictSelected = getSubDistrict.data.data.filter((subDistrict: any) => {
      return parseInt(subDistrict.sub_district_code) === parseInt(facilityData.subDistrictLGDCode);
    });
    const selectedSubDistrict = subDistrictSelected[0];

    // const getUlb = await axios.getWithCache(`${endpoints.getUlb}/${stateSelected[0].state_id}`, Auth.loggedIn());
    // const getUlb_options = getUlb?.data.data?.map((key: any) => ({
    //   value: `${key.ulb_name}-${key.ulb_code}`,
    //   label: `${key.ulb_name}-${key.ulb_code}`,
    //   id: key.ulb_id,
    //   code: key.ulb_code,
    // }));
    const getBlock = await axios.getWithCache(`${endpoints.getBlock(districtSelected[0].district_id)}`, Auth.loggedIn());
    const getHealthBlock = await axios.getWithCache(`${endpoints.getHealthBlock(districtSelected[0].district_id)}`, Auth.loggedIn());
    const subDivision = await axios.getWithCache(`${endpoints.getSubDivision(districtSelected[0].district_id)}`, Auth.loggedIn());

    //Updating urban dropdown fields
    setFormData3_1((hierarchy_details_urban: any) => ({
      ...hierarchy_details_urban,
      state: {
        ...hierarchy_details_urban.state,
        '#options': getState.data.data,
        '#isDisabled': true
      },
      district: {
        ...hierarchy_details_urban.district,
        '#options': getDistrict.data.data,
        '#isDisabled': true
      },
      // ulb: {
      //   ...hierarchy_details_urban.ulb,
      //   '#options': getUlb_options,
      // },
      sub_district: {
        ...hierarchy_details_urban.sub_district,
        '#options': getSubDistrict?.data?.data,
        '#isDisabled':selectedSubDistrict?.sub_district_name ? true : false
      },
      health_block: {
        ...hierarchy_details_urban.health_block,
        '#options': getHealthBlock.data.data,
      },
      sub_division: {
        ...hierarchy_details_urban.sub_division,
        '#options': subDivision.data.data,
      }
    }));

    const updatedHierarchyDetailsUrbanFormState = {
      ...hierarchyDetailsUrbanFormState,
      state: {
        ...hierarchyDetailsUrbanFormState.state,
        value: `${selectedState.state_name}-${selectedState.state_code}`,
        id: `${selectedState.state_id}`,
        code: `${selectedState.state_code}`

      },
      district: {
        ...hierarchyDetailsUrbanFormState.district,
        value: `${selectedDistrict.district_name}-${selectedDistrict.district_code}`,
        id: `${selectedDistrict.district_id}`,
        code: `${selectedDistrict.district_code}`
      },
      sub_district: {
        ...hierarchyDetailsUrbanFormState.sub_district,
        value:selectedSubDistrict?.sub_district_name? `${selectedSubDistrict?.sub_district_name}-${selectedSubDistrict?.sub_district_code}`:'',
        id:selectedSubDistrict?.sub_district_name? `${selectedSubDistrict?.sub_district_id}`:'',
        code:selectedSubDistrict?.sub_district_name? `${selectedSubDistrict?.sub_district_code}`:''
      },
    }

    //Updating rural dropdown fields
    setFormData3_2((hierarchy_details_rural: any) => ({
      ...hierarchy_details_rural,
      state: {
        ...hierarchy_details_rural.state,
        '#options': getState.data.data,
        '#isDisabled': true
      },
      district: {
        ...hierarchy_details_rural.district,
        '#options': getDistrict.data.data,
        '#isDisabled': true
      },
      block: {
        ...hierarchy_details_rural.block,
        '#options': getBlock.data.data,
      },
      sub_district: {
        ...hierarchy_details_rural.sub_district,
        '#options': getSubDistrict?.data?.data,
        '#isDisabled':selectedSubDistrict?.sub_district_name ? true : false
      },
      health_block: {
        ...hierarchy_details_rural.health_block,
        '#options': getHealthBlock.data.data,
      },
      sub_division: {
        ...hierarchy_details_rural.sub_division,
        '#options': subDivision.data.data,
      }
    }));

    const updatedHierarchyDetailsRuralFormState = {
      ...hierarchyDetailsRuralFormState,
      state: {
        ...hierarchyDetailsRuralFormState.state,
        value: `${selectedState.state_name}-${selectedState.state_code}`,
        id: `${selectedState.state_id}`,
        code: `${selectedState.state_code}`
      },
      district: {
        ...hierarchyDetailsRuralFormState.district,
        value: `${selectedDistrict.district_name}-${selectedDistrict.district_code}`,
        id: `${selectedDistrict.district_id}`,
        code: `${selectedDistrict.district_code}`
      },
      sub_district: {
        ...hierarchyDetailsRuralFormState.sub_district,
        value: selectedSubDistrict?.sub_district_name?`${selectedSubDistrict?.sub_district_name}-${selectedSubDistrict?.sub_district_code}`: '',
        id:selectedSubDistrict?.sub_district_name? `${selectedSubDistrict?.sub_district_id}`:'',
        code:selectedSubDistrict?.sub_district_name? `${selectedSubDistrict?.sub_district_code}`:''
      },
    }





    setFacilityDetailsFormState(updatedFacilityDetailsFormState);
    // setEnrollmentDetailsFormState(updatedEnrollmentDetailsFormState);
    setLocationDetailsFormState(updatedLocationDetailsFormState);
    setHierarchyDetailsRuralFormState(updatedHierarchyDetailsRuralFormState);
    setHierarchyDetailsUrbanFormState(updatedHierarchyDetailsUrbanFormState);
  }



  const contents = [
    <div key="Facility Details">
      <FacilityDetails handleFormChange={handleFacilityDetailsFormChange} handleHfrIdvalidationBeforeVerify={handleHfrIdvalidationBeforeVerify} formState={facilityDetailsFormState} formData={formData1} handleFacilityData={handleFacilityData} />
    </div>,
    <div key="Enrollment Details">
      <EnrollmentDetails handleFormChange={handleEnrollmentDetailsFormChange} formState={enrollmentDetailsFormState} formData={formData2} />
    </div>,
    <div key="Hierarchy">
      <HierarchyDetails handleFormChange={handleHierarchyDetailsFormChange}
        formState={facilityDetailsFormState.rural_urban.value === 'Rural' ? hierarchyDetailsRuralFormState : hierarchyDetailsUrbanFormState}
        formData={facilityDetailsFormState.rural_urban.value === 'Rural' ? formData3_2 : formData3_1} 
        onInputChange={handleInputChange}
        />
    </div>,
    <div key="Location Details">
      <LocationDetails
        handleLocationDetailsDataChangeOnMapFails={handleLocationDetailsDataChangeOnMapFails}
        handleFormChange={handleLocationDetailsFormChange}
        handleLocationDetailsError={handleLocationDetailsError}
        formState={locationDetailsFormState}
        formData={locationDetailsFormData}
        facilityFormState={facilityDetailsFormState.rural_urban.value === 'Rural' ? hierarchyDetailsRuralFormState : hierarchyDetailsUrbanFormState}
      />
    </div>,
    <div key="Coverage Details">
      {/* <CoverageDetails  handleFormChange={handleCoverageDetailsFormChange} formState={coverageDetailsFormState} formData={formData5} /> */}
      <CoverageDetails handleFormChange={handleCoverageDetailsFormChange} onDropDownClick={onDropDownClick}
        formState={ coverageDetailsFormState }
        formData={ formData5 } />
    </div>,
  ];

  const resetOnHFREmpty = () => {
    //reseting state and district when HFR id is blank:
    const userTypeName:any = localStorage.getItem('userTypeName');
    const updatedHierarchyDetailsRuralFormState = {
      ...hierarchyDetailsRuralFormState,
      state: {
        ...hierarchyDetailsRuralFormState.state,
        value: (!['Super Admin User', 'National Level User'].includes(userTypeName))? hierarchyDetailsRuralFormState.state.value: '',
        id: (!['Super Admin User', 'National Level User'].includes(userTypeName))? hierarchyDetailsRuralFormState.state.id: '',
        code: (!['Super Admin User', 'National Level User'].includes(userTypeName))? hierarchyDetailsRuralFormState.state.code: '',
      },
      district: {
        ...hierarchyDetailsRuralFormState.district,
        value: (!['Super Admin User', 'National Level User','State Level User'].includes(userTypeName))? hierarchyDetailsRuralFormState.district.value: '',
        id: (!['Super Admin User', 'National Level User','State Level User'].includes(userTypeName))? hierarchyDetailsRuralFormState.district.id: '',
        code: (!['Super Admin User', 'National Level User','State Level User'].includes(userTypeName))? hierarchyDetailsRuralFormState.district.code: '',
      },
      sub_district: {
        ...hierarchyDetailsRuralFormState.sub_district,
        value: ``,
      },
      block: {
        ...hierarchyDetailsRuralFormState.block,
        value: ``,
      },
      sub_division: {
        ...hierarchyDetailsRuralFormState.sub_division,
        value: ``,
      },
      health_block: {
        ...hierarchyDetailsRuralFormState.health_block,
        value: ``,
      },
      village: {
        ...hierarchyDetailsRuralFormState.village,
        value: ``,
      },
      gram_panchayat: {
        ...hierarchyDetailsRuralFormState.gram_panchayat,
        value: ``,
      },
    }

    const updatedHierarchyDetailsUrbanFormState = {
      ...hierarchyDetailsUrbanFormState,
      state: {
        ...hierarchyDetailsUrbanFormState.state,
        value: (!['Super Admin User', 'National Level User'].includes(userTypeName))? hierarchyDetailsUrbanFormState.state.value: '',
        id: (!['Super Admin User', 'National Level User'].includes(userTypeName))? hierarchyDetailsUrbanFormState.state.id: '',
        code: (!['Super Admin User', 'National Level User'].includes(userTypeName))? hierarchyDetailsUrbanFormState.state.code: '',
      },
      district: {
        ...hierarchyDetailsUrbanFormState.district,
        value: (!['Super Admin User', 'National Level User','State Level User'].includes(userTypeName))? hierarchyDetailsUrbanFormState.district.value: '',
        id: (!['Super Admin User', 'National Level User','State Level User'].includes(userTypeName))? hierarchyDetailsUrbanFormState.district.id: '',
        code: (!['Super Admin User', 'National Level User','State Level User'].includes(userTypeName))? hierarchyDetailsUrbanFormState.district.code: '',
      },
      sub_district: {
        ...hierarchyDetailsUrbanFormState.sub_district,
        value: ``,
      },
      sub_division: {
        ...hierarchyDetailsUrbanFormState.sub_division,
        value: ``,
      },
      health_block: {
        ...hierarchyDetailsUrbanFormState.health_block,
        value: ``,
      },
      ward: {
        ...hierarchyDetailsUrbanFormState.ward,
        value: ``,
      },
    }

    setFormData3_1((hierarchy_details_urban: any) => ({
      ...hierarchy_details_urban,
      state: {
        ...hierarchy_details_urban.state,
        '#isDisabled': (!['Super Admin User', 'National Level User'].includes(userTypeName)) ? true : false,
      },
      district: {
        ...hierarchy_details_urban.district,
        '#isDisabled': (!['Super Admin User', 'National Level User','State Level User'].includes(userTypeName)) ? true : false,
      },
      sub_district: {
        ...hierarchy_details_urban.sub_district,
        '#isDisabled': false
      }
    }));

    setFormData3_2((hierarchy_details_rural: any) => ({
      ...hierarchy_details_rural,
      state: {
        ...hierarchy_details_rural.state,
        '#isDisabled': (!['Super Admin User', 'National Level User'].includes(userTypeName)) ? true : false,
      },
      district: {
        ...hierarchy_details_rural.district,
        '#isDisabled': (!['Super Admin User', 'National Level User','State Level User'].includes(userTypeName)) ? true : false,
      },
      sub_district: {
        ...hierarchy_details_rural.sub_district,
        '#isDisabled': false
      }
    }));

    //reset pincode adress lat long
    const updatedLocationDetailsFormState = {
      ...locationDetailsFormState,
      pincode: {
        ...locationDetailsFormState.pincode,
        value: '',
      },
      lattitude: {
        ...locationDetailsFormState.lattitude,
        value: ''
      },
      longitude: {
        ...locationDetailsFormState.longitude,
        value: ''
      },
      address: {
        ...locationDetailsFormState.address,
        value: ''
      },
    }
    setHierarchyDetailsRuralFormState(updatedHierarchyDetailsRuralFormState);
    setHierarchyDetailsUrbanFormState(updatedHierarchyDetailsUrbanFormState);
    setLocationDetailsFormState(updatedLocationDetailsFormState);
  }


  const handleSave = async (activeIndex: number) => {
    const tempError = [];
    if (activeIndex === 0) {
      const facilityDetailsTempChange = {
        ...facilityDetailsFormState
      };
      let isFormError = false;
      Object.keys(facilityDetailsTempChange).map((item) => {

        if (item === 'hpr_id') {
          if (!facilityDetailsTempChange.hpr_id.value) {
            // isFormError = false;
            facilityDetailsTempChange.hpr_id.isError = false;
            facilityDetailsTempChange.hpr_id.message = '';
            facilityDetailsTempChange.hpr_id.verifiedDetails = '';


            resetOnHFREmpty();
          }
          // else if (!/^\w{12}$/.test(facilityDetailsTempChange.hpr_id.value)) {
          //   isFormError = true;
          //   facilityDetailsTempChange.hpr_id.isError = true;
          //   facilityDetailsTempChange.hpr_id.message = 'HFR ID Must Contain 12 Digits. Re-Enter a valid HFR ID';
          // }
          // else if (facilityDetailsTempChange.hpr_id.value == '000000000000') {
          //   isFormError = true;
          //   facilityDetailsTempChange.hpr_id.isError = true;
          //   facilityDetailsTempChange.hpr_id.message = 'HFR ID Cannot be all Zeros. Re-Enter a valid HFR ID';
          // }
          // else if (facilityDetailsTempChange.hpr_id.verifiedDetails === 'Already Exist') {
          //   isFormError = true;
          //   facilityDetailsTempChange.hpr_id.isError = true;
          //   facilityDetailsTempChange.hpr_id.message = 'Entered HFR ID already exist.';
          // }
          //  else if (facilityDetailsTempChange.hpr_id.verifiedDetails === 'not verified') {
          //   isFormError = true;
          //   facilityDetailsTempChange.hpr_id.isError = true;
          //   facilityDetailsTempChange.hpr_id.message = 'Entered HFR ID is not verified.';
          // }
          else if (facilityDetailsTempChange.hpr_id.isError == true) {
            isFormError = true;
          }
          if (facilityDetailsTempChange.hpr_id.verifiedDetails == 'not verified') {
            facilityDetailsTempChange.hpr_id.isError = true;
            facilityDetailsTempChange.hpr_id.message = 'HFR ID not yet verified.';
            facilityDetailsTempChange.facility_name.isError = true;
            facilityDetailsTempChange.facility_name.message = 'Matching score needs to be recalculated.';
            isFormError = true;
          }
          else if (facilityDetailsTempChange.hpr_id.isError == true) {
            isFormError = true;
          }
          else {
            facilityDetailsTempChange.hpr_id.isError = false;
            //isFormError = false;
          }
        }
        else if (item === 'facility_name') {
          if (facilityDetailsTempChange.facility_name.value.length <= 0) {
            isFormError = true;
            facilityDetailsTempChange.facility_name.isError = true;
            facilityDetailsTempChange.facility_name.message = 'Enter facility name to continue.';
            facilityDetailsTempChange.hpr_id.verifiedDetails = '';
          }
          // else if(facilityDetailsTempChange.facility_name.message == 'Matchine score <70 %.'){
          //   isFormError = true;
          //   facilityDetailsTempChange.facility_name.isError = true;
          //   facilityDetailsTempChange.facility_name.message = 'Health Facility Name cannot have special characters';
          // }
          else if (!/^[a-zA-Z0-9\s.,\-@#$%&*!+?():'"/]+$/.test(facilityDetailsTempChange.facility_name.value)) {
            isFormError = true;
            facilityDetailsTempChange.facility_name.isError = true;
            facilityDetailsTempChange.facility_name.message = 'Health Facility Name cannot have special characters.';
          }
          else if (facilityDetailsTempChange.facility_name.value.length > 500) {
            isFormError = true;
            facilityDetailsTempChange.facility_name.isError = true;
            facilityDetailsTempChange.facility_name.message = 'Health Facility Name cannot be more than 500 characters.';
          }
          else if (facilityDetailsTempChange.facility_name.isError == true) {
            isFormError = true;
          }
          else {
            facilityDetailsTempChange.facility_name.isError = false;
            // isFormError = false;
          }
        }
        else if (item === 'facility_type') {
          if (!facilityDetailsTempChange.facility_type.value) {
            isFormError = true;
            facilityDetailsTempChange.facility_type.isError = true;
            facilityDetailsTempChange.facility_type.message = 'Select facility type from the dropdown.';
          }
          else {
            facilityDetailsTempChange.facility_type.isError = false;
          }
        }
        // else if (item === 'facility_category') {

        //     if (facilityDetailsTempChange.facility_category.value.length <= 0) {
        //       isFormError = true;
        //       facilityDetailsTempChange.facility_category.isError = true;
        //       facilityDetailsTempChange.facility_category.message = 'Select facility category from the dropdown.';
        //     }
        //     else {
        //       facilityDetailsTempChange.facility_category.isError = false;
        //       //isFormError = false;
        //     }
        //   }
        else if (item === 'ownership') {
          if (!facilityDetailsTempChange.ownership.value) {
            isFormError = true;
            facilityDetailsTempChange.ownership.isError = true;
            facilityDetailsTempChange.ownership.message = 'Select ownership to continue.';
          }
          else {
            facilityDetailsTempChange.ownership.isError = false;
          }
        }
        else if (item === 'administrative_body') {
          //length is greater than 0
          //  if(facilityDetailsFormState){}


          if (formData1?.administrative_body['#options']?.length > 0) {
            if (!facilityDetailsTempChange.administrative_body.value) {
              isFormError = true;
              facilityDetailsTempChange.administrative_body.isError = true;
              facilityDetailsTempChange.administrative_body.message = 'Select administrative body to continue.';
            }
            else {
              facilityDetailsTempChange.administrative_body.isError = false;
            }
          }


          //formData1


        }
        else if (item === 'central_govt_dept') {
          if (facilityDetailsTempChange.administrative_body.value === "Central Government" && formData1.central_govt_dept['#required']) {
            if (!facilityDetailsTempChange.central_govt_dept.value) {
              isFormError = true;
              facilityDetailsTempChange.central_govt_dept.isError = true;
              facilityDetailsTempChange.central_govt_dept.message = 'Select central government department to continue.';
            }
            else {
              facilityDetailsTempChange.central_govt_dept.isError = false;
            }
          }
        }
        else if (item === 'rural_urban') {
          if (!facilityDetailsTempChange.rural_urban.value) {
            isFormError = true;
            facilityDetailsTempChange.rural_urban.isError = true;
            facilityDetailsTempChange.rural_urban.message = 'Select an input to continue.';
          }
          else {
            facilityDetailsTempChange.rural_urban.isError = false;
          }
        }

      })

      setFacilityDetailsFormState(facilityDetailsTempChange);
      // errors[0] = isFormError;
      tempError[0] = isFormError;
    }

    if (activeIndex === 1) {
      const enrollmentDetailsTempChange = {
        ...enrollmentDetailsFormState
      }
      let isFormError = false;
      Object.keys(enrollmentDetailsTempChange).map((item) => {
        if (item === 'date_of_enrollment') {
          if (!enrollmentDetailsTempChange.date_of_enrollment.value) {
            enrollmentDetailsTempChange.date_of_enrollment.isError = true;
            enrollmentDetailsTempChange.date_of_enrollment.message = 'Select date of enrollment to continue.';
            isFormError = true;
          }
          else {
            enrollmentDetailsTempChange.date_of_enrollment.isError = false;
          }
        }
        else if (item === 'effective_from_date') {
          if (!enrollmentDetailsTempChange.effective_from_date.value) {
            isFormError = true;
            enrollmentDetailsTempChange.effective_from_date.isError = true;
            enrollmentDetailsTempChange.effective_from_date.message = 'Select effective from date to continue.';
          }
          else {
            enrollmentDetailsTempChange.effective_from_date.isError = false;
          }
        }
        else if (item === 'status') {

          if (enrollmentDetailsTempChange.status.isDisable === true) {
            enrollmentDetailsTempChange.status.isError = false;
          }
          else if (!enrollmentDetailsTempChange.status.value) {
            isFormError = true;
            enrollmentDetailsTempChange.status.isError = true;
            enrollmentDetailsTempChange.status.message = 'Select status to continue.';
          }
          else {
            enrollmentDetailsTempChange.status.isError = false;

          }
        }
        else if (item === 'sanctionedbed_count') {
          if (!enrollmentDetailsTempChange.sanctionedbed_count.value) {
            enrollmentDetailsTempChange.sanctionedbed_count.isError = false;
            enrollmentDetailsTempChange.sanctionedbed_count.message = '';
          }
          else if (enrollmentDetailsTempChange.sanctionedbed_count.value.length > 4) {
            isFormError = true;
            enrollmentDetailsTempChange.sanctionedbed_count.isError = true;
            enrollmentDetailsTempChange.sanctionedbed_count.message = 'Sanctioned bed count should be limited to 4 digits';
          } else {
            enrollmentDetailsTempChange.sanctionedbed_count.isError = false;
          }
        }
        else if (item === 'functionalbed_count') {
          if (!enrollmentDetailsTempChange.functionalbed_count.value) {
            enrollmentDetailsTempChange.functionalbed_count.isError = false;
            enrollmentDetailsTempChange.functionalbed_count.message = '';
          }
          else if (enrollmentDetailsTempChange.functionalbed_count.value.length > 4) {
            isFormError = true;
            enrollmentDetailsTempChange.functionalbed_count.isError = true;
            enrollmentDetailsTempChange.functionalbed_count.message = 'functional bed count should be limited to 4 digits';
          }
          else if (parseInt(enrollmentDetailsTempChange.functionalbed_count.value) > parseInt(enrollmentDetailsTempChange.sanctionedbed_count.value)) {
            isFormError = true;
            enrollmentDetailsTempChange.functionalbed_count.isError = true;
            enrollmentDetailsTempChange.functionalbed_count.message = 'Functional bed count should be less than or equal to sanctioned bed count';
          } else {
            enrollmentDetailsTempChange.functionalbed_count.isError = false;
          }
        }

      })
      // errors[1] = isFormError;
      tempError[1] = isFormError;
      setEnrollmentDetailsFormState(enrollmentDetailsTempChange);
    }









    if (activeIndex === 2) {

      if (facilityDetailsFormState.rural_urban.value === 'Rural') {


        const hierarchyDetailsFormStateTempChange = {
          ...hierarchyDetailsRuralFormState
        }
        let isFormError = false;
        Object.keys(hierarchyDetailsFormStateTempChange).map((item) => {

          if (item === 'state') {
            if (!hierarchyDetailsFormStateTempChange.state.value) {
              hierarchyDetailsFormStateTempChange.state.isError = true;
              hierarchyDetailsFormStateTempChange.state.message = 'Select state from the dropdown.';
              isFormError = true;
            }
            else {
              hierarchyDetailsFormStateTempChange.state.isError = false;
            }
          }
          else if (item === 'district') {
            if (!hierarchyDetailsFormStateTempChange.district.value) {
              isFormError = true;
              hierarchyDetailsFormStateTempChange.district.isError = true;
              hierarchyDetailsFormStateTempChange.district.message = 'Select district from the dropdown.';
            }
            else {
              hierarchyDetailsFormStateTempChange.district.isError = false;
            }
          }
          else if (item === 'sub_district') {


            if (!hierarchyDetailsFormStateTempChange.sub_district.value && formData3_2[item]['#required'] && !formData3_2[item]['#isDisabled']) {
              isFormError = true;
              hierarchyDetailsFormStateTempChange.sub_district.isError = true;
              hierarchyDetailsFormStateTempChange.sub_district.message = 'Select sub district from the dropdown.';
            }
            else {
              hierarchyDetailsFormStateTempChange.sub_district.isError = false;
            }



          }
          else if (item === 'block') {
            if (!hierarchyDetailsFormStateTempChange.block.value && formData3_2[item]['#required'] && !formData3_2[item]['#isDisabled']) {
              isFormError = true;
              hierarchyDetailsFormStateTempChange.block.isError = true;
              hierarchyDetailsFormStateTempChange.block.message = 'Select Block from the dropdown.';
            }
            else {
              hierarchyDetailsFormStateTempChange.block.isError = false;
            }


          }
          else if (item === 'village') {

            if (!hierarchyDetailsFormStateTempChange.village.value && formData3_2[item]['#required'] && !formData3_2[item]['#isDisabled'] && formData3_2[item]['#isVisible']) {
              isFormError = true;
              hierarchyDetailsFormStateTempChange.village.isError = true;
              hierarchyDetailsFormStateTempChange.village.message = 'Select village from the dropdown.';
            }
            else {
              hierarchyDetailsFormStateTempChange.village.isError = false;
            }


          }
          else if (item === 'gram_panchayat') {
            if (!hierarchyDetailsFormStateTempChange.gram_panchayat.value && formData3_2[item]['#required'] && !formData3_2[item]['#isDisabled'] && formData3_2[item]['#isVisible']) {
              isFormError = true;
              hierarchyDetailsFormStateTempChange.gram_panchayat.isError = true;
              hierarchyDetailsFormStateTempChange.gram_panchayat.message = 'Select Gram Panchayat / ADC Village from the dropdown.';
            }
            else {
              hierarchyDetailsFormStateTempChange.gram_panchayat.isError = false;
            }
          }



        })
        tempError[2] = isFormError;
        setHierarchyDetailsFormState(hierarchyDetailsFormStateTempChange);

      } else {


        const hierarchyDetailsFormStateTempChange = {
          ...hierarchyDetailsUrbanFormState
        }
        let isFormError = false;
        Object.keys(hierarchyDetailsFormStateTempChange).map((item) => {

          if (item === 'state') {
            if (!hierarchyDetailsFormStateTempChange.state.value) {
              hierarchyDetailsFormStateTempChange.state.isError = true;
              hierarchyDetailsFormStateTempChange.state.message = 'Select state from the dropdown.';
              isFormError = true;
            }
            else {
              hierarchyDetailsFormStateTempChange.state.isError = false;
            }
          }
          else if (item === 'district') {
            if (!hierarchyDetailsFormStateTempChange.district.value) {
              isFormError = true;
              hierarchyDetailsFormStateTempChange.district.isError = true;
              hierarchyDetailsFormStateTempChange.district.message = 'Select district from the dropdown.';
            }
            else {
              hierarchyDetailsFormStateTempChange.district.isError = false;
            }
          }
          else if (item === 'ulb') {

            if (!hierarchyDetailsFormStateTempChange.ulb.value && formData3_1[item]['#required'] && !formData3_1[item]['#isDisabled']) {
              isFormError = true;
              hierarchyDetailsFormStateTempChange.ulb.isError = true;
              hierarchyDetailsFormStateTempChange.ulb.message = 'Select ULB from the dropdown.';
            }
            else {
              hierarchyDetailsFormStateTempChange.ulb.isError = false;
            }

          }
          else if (item === 'sub_district') {

            if (!hierarchyDetailsFormStateTempChange.sub_district.value && formData3_1[item]['#required'] && !formData3_1[item]['#isDisabled']) {
              isFormError = true;
              hierarchyDetailsFormStateTempChange.sub_district.isError = true;
              hierarchyDetailsFormStateTempChange.sub_district.message = 'Select sub district from the dropdown.';
            }
            else {
              hierarchyDetailsFormStateTempChange.sub_district.isError = false;
            }


          }
          else if (item === 'ward') {
            if (!hierarchyDetailsFormStateTempChange.ward.value && formData3_1[item]['#required'] && !formData3_1[item]['#isDisabled']) {
              isFormError = true;
              hierarchyDetailsFormStateTempChange.ward.isError = true;
              hierarchyDetailsFormStateTempChange.ward.message = 'Select ward from the dropdown.';
            }
            else {
              hierarchyDetailsFormStateTempChange.ward.isError = false;
            }
          }



        })
        // errors[2] = isFormError;
        tempError[2] = isFormError;
        setHierarchyDetailsFormState(hierarchyDetailsFormStateTempChange);

      }

    }





    if (activeIndex === 3) {

      const locationDetailsTempChange = {
        ...locationDetailsFormState
      }
      let isFormError = false;
      Object.keys(locationDetailsTempChange).map((item) => {
        if (item === 'pincode') {
          if (!locationDetailsTempChange.pincode.value && locationDetailsFormData.pincode['#required'] === true) {
            locationDetailsTempChange.pincode.isError = true;
            locationDetailsTempChange.pincode.message = 'Enter valid pincode to continue.';
            isFormError = true;
          }
          else if ((!/^\d{6}$/.test(locationDetailsTempChange.pincode.value)) && locationDetailsFormData.pincode['#required'] === true) {
            locationDetailsTempChange.pincode.isError = true;
            locationDetailsTempChange.pincode.message = 'Enter valid pincode to continue.';
            isFormError = true;
          } else {
            locationDetailsTempChange.pincode.isError = false;
          }
        } else if (item === 'lattitude') {
          if (!locationDetailsTempChange.lattitude.value) {
            isFormError = true;
            locationDetailsTempChange.lattitude.isError = true;
            locationDetailsTempChange.lattitude.message = 'Enter valid latitude to continue.';
          } else if (!/^-?\d{1,3}\.\d+$/.test(locationDetailsTempChange.lattitude.value) ||
            parseFloat(locationDetailsTempChange.lattitude.value) < -90 ||
            parseFloat(locationDetailsTempChange.lattitude.value) > 90) {
            isFormError = true;
            locationDetailsTempChange.lattitude.isError = true;
            locationDetailsTempChange.lattitude.message = 'Enter valid latitude to continue.';
          } else {
            locationDetailsTempChange.lattitude.isError = false;
          }
        }
        else if (item === 'longitude') {
          if (!locationDetailsTempChange.longitude.value) {
            isFormError = true;
            locationDetailsTempChange.longitude.isError = true;
            locationDetailsTempChange.longitude.message = 'Enter valid longitude to continue.';
          } else if (!/^-?\d{1,3}\.\d+$/.test(locationDetailsTempChange.longitude.value) ||
            parseFloat(locationDetailsTempChange.longitude.value) < -180 ||
            parseFloat(locationDetailsTempChange.longitude.value) > 180) {
            isFormError = true;
            locationDetailsTempChange.longitude.isError = true;
            locationDetailsTempChange.longitude.message = 'Enter valid longitude to continue.';
          } else {
            locationDetailsTempChange.longitude.isError = false;
          }
        }
        else if (item === 'address') {
          if (!locationDetailsTempChange.address.value) {
            isFormError = true;
            locationDetailsTempChange.address.isError = true;
            locationDetailsTempChange.address.message = 'Enter address to continue.';
          }
          else {
            locationDetailsTempChange.address.isError = false;
          }
        }
      })
      // validate location details 

      // try {
      //   const promise1 = await axios.get(`${config.googleMapApiUrl}?latlng=${parseFloat(locationDetailsTempChange.lattitude.value)},${parseFloat(locationDetailsTempChange.longitude.value)}&key=${config.googleMapToken}`);
      //   const promise2 = await axios.get(`${config.googleMapApiUrl}?address=${locationDetailsTempChange.pincode.value}&key=${config.googleMapToken}`);
      //   const facilityFormState = facilityDetailsFormState.rural_urban.value === 'Rural' ? hierarchyDetailsRuralFormState : hierarchyDetailsUrbanFormState
      //   const res = await Promise.all([promise1, promise2]);
      //   if (res[0].data && res[0].data.status === 'OK') {
      //     const response1 = res[0].data.results && res[0].data.results[0];
      //     const { address_components, formatted_address } = response1;
      //     if (formatted_address && !formatted_address.toLocaleLowerCase().includes(facilityFormState.state.value.split('-')[0].toLocaleLowerCase())) {
      //       isFormError = true;
      //       locationDetailsTempChange.longitude.isError = true;
      //       locationDetailsTempChange.longitude.message = 'Longitude is not within state range';
      //       locationDetailsTempChange.lattitude.isError = true;
      //       locationDetailsTempChange.lattitude.message = 'Lattitude is not within state range';
      //       // handleIslocationValidated(true);
      //     }
      //     // if (address_components && address_components.length > 0) {
      //     //   address_components.forEach((i: any) => {
      //     //     if (i.types.includes("postal_code") && i.long_name != locationDetailsTempChange.pincode.value) {
      //     //       isFormError = true;
      //     //       locationDetailsTempChange.pincode.isError = true;
      //     //       locationDetailsTempChange.pincode.message = 'Pincode is not matching with Lattitude and Longitude';
      //     //     }
      //     //   });
      //     // }
      //   }
      //   if (res[1].data && res[1].data.status === 'OK') {
      //     const response2 = res[1].data.results && res[1].data.results[0];
      //     const { formatted_address } = response2;
      //     if (formatted_address && !formatted_address.toLocaleLowerCase().includes(facilityFormState.state.value.split('-')[0].toLocaleLowerCase())) {
      //       isFormError = true;
      //       locationDetailsTempChange.pincode.isError = true;
      //       locationDetailsTempChange.pincode.message = 'Pincode is not within state range';
      //     }
      //   }
      //   if (res[1].data && res[1].data.status === 'ZERO_RESULTS') {
      //     isFormError = true;
      //     locationDetailsTempChange.pincode.isError = true;
      //     locationDetailsTempChange.pincode.message = 'Pincode is not within state range or invalid pincode';
      //   }
      // } catch (error) {
      //   
      // }

      tempError[3] = isFormError;
      setLocationDetailsFormState(locationDetailsTempChange);

      if (!isFormError) {
        // try {
        //   const promise1 = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${parseFloat(locationDetailsTempChange.lattitude.value)},${parseFloat(locationDetailsTempChange.longitude.value)}&key=AIzaSyBKY91HLZr3ziBWP833VjiOtOjgrk44uNg`);
        //   const promise2 = await axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${locationDetailsTempChange.pincode.value}&key=AIzaSyBKY91HLZr3ziBWP833VjiOtOjgrk44uNg`);
        //   const facilityFormState = facilityDetailsFormState.rural_urban.value === 'Rural' ? hierarchyDetailsRuralFormState : hierarchyDetailsUrbanFormState
        //   const res = await Promise.all([promise1, promise2]);
        //   if (res[0].data && res[0].data.status === 'OK') {
        //     const response1 = res[0].data.results && res[0].data.results[0];
        //     const { address_components, formatted_address } = response1;
        //     if (formatted_address && !formatted_address.toLocaleLowerCase().includes(facilityFormState.state.value.split('-')[0].toLocaleLowerCase())) {
        //       isFormError = true;
        //       locationDetailsTempChange.longitude.isError = true;
        //       locationDetailsTempChange.longitude.message = 'Longitude is not within state range';
        //       locationDetailsTempChange.lattitude.isError = true;
        //       locationDetailsTempChange.lattitude.message = 'Lattitude is not within state range';
        //       // handleIslocationValidated(true);
        //     }
        //     // if (address_components && address_components.length > 0) {
        //     //   address_components.forEach((i: any) => {
        //     //     if (i.types.includes("postal_code") && i.long_name != locationDetailsTempChange.pincode.value) {
        //     //       isFormError = true;
        //     //       locationDetailsTempChange.pincode.isError = true;
        //     //       locationDetailsTempChange.pincode.message = 'Pincode is not matching with Lattitude and Longitude';
        //     //     }
        //     //   });
        //     // }
        //   }
        //   if (res[1].data && res[1].data.status === 'OK') {
        //     const response2 = res[1].data.results && res[1].data.results[0];
        //     const { formatted_address } = response2;
        //     if (formatted_address && !formatted_address.toLocaleLowerCase().includes(facilityFormState.state.value.split('-')[0].toLocaleLowerCase())) {
        //       isFormError = true;
        //       locationDetailsTempChange.pincode.isError = true;
        //       locationDetailsTempChange.pincode.message = 'Pincode is not within state range';
        //     }
        //   }
        //   if (res[1].data && res[1].data.status === 'ZERO_RESULTS') {
        //     isFormError = true;
        //     locationDetailsTempChange.pincode.isError = true;
        //     locationDetailsTempChange.pincode.message = 'Pincode is not within state range or invalid pincode';
        //   }
        // } catch (error) {
        //   
        // }
        if (!facilityGeoMap.mapServicesDown && config.enableArcGISMap === 'ON') {
        if (!geometryEngine.contains(facilityGeoMap.distFenceGeometry, facilityGeoMap.mapPointer)) {
          toast.error("lattitude, longitude and address is not within district range", {
            position: "top-center",
          });

          return;
        }

        if (facilityGeoMap.isManualLatLong) {
          toast.warning("lattitude, longitude is upadted manually, please locate it on map to proceed.", {
            position: "top-center",
          });

          return;
        }
      }
      }
    }


    if (activeIndex === 4) {
        const coverageDetailsFormStateTempChange = {
          ...coverageDetailsFormState
        }
        let isFormError = false;
        Object.keys(coverageDetailsFormStateTempChange).map((item) => {
          // if (item === 'linked_facilities') {
          //   if (isLinkedFacilityAvailable) {
          //     if (Object.keys(coverageDetailsFormStateTempChange.linked_facilities.value).length <= 0) {
          //       coverageDetailsFormStateTempChange.linked_facilities.isError = true;
          //       coverageDetailsFormStateTempChange.linked_facilities.message = 'Select linked facilities from the dropdown.';
          //       isFormError = true;
          //     }
          //     else {
          //       coverageDetailsFormStateTempChange.linked_facilities.isError = false;
          //       isFormError = false;
          //     }
          //   }

          // }

          if(HBSDSelected){
             if(!isGrampanchayat){
              if (item === 'wards_covered' || item === 'villages_covered') {
                  if (Object.keys(coverageDetailsFormStateTempChange.villages_covered.value)?.length === 0 && Object.keys(coverageDetailsFormStateTempChange.wards_covered.value)?.length === 0) {
                    coverageDetailsFormStateTempChange.wards_covered.isError = true;
                    coverageDetailsFormStateTempChange.wards_covered.message = 'Select wards from the dropdown.';
                    isFormError = true;
                    coverageDetailsFormStateTempChange.villages_covered.isError = true;
                    coverageDetailsFormStateTempChange.villages_covered.message = 'Select villages from the dropdown.';
                  }
                  else {
                    coverageDetailsFormStateTempChange.wards_covered.isError = false;
                    coverageDetailsFormStateTempChange.villages_covered.isError = false;
                  }
              }
            }
            else if(isGrampanchayat){
              if (item === 'wards_covered' || item === 'gram_panchayat_covered') {
                if (Object.keys(coverageDetailsFormStateTempChange.gram_panchayat_covered.value)?.length === 0 && Object.keys(coverageDetailsFormStateTempChange.wards_covered.value)?.length === 0) {
                  coverageDetailsFormStateTempChange.wards_covered.isError = true;
                  coverageDetailsFormStateTempChange.wards_covered.message = 'Select wards from the dropdown.';
                  isFormError = true;
                  coverageDetailsFormStateTempChange.gram_panchayat_covered.isError = true;
                  coverageDetailsFormStateTempChange.gram_panchayat_covered.message = 'Select Gram Panchayats / ADC Villages from the dropdown.';
                }
                else {
                  coverageDetailsFormStateTempChange.wards_covered.isError = false;
                  coverageDetailsFormStateTempChange.gram_panchayat_covered.isError = false;
                }
            }
            }
          }
          else{
            if (item === 'wards_covered') {
              if (Object.keys(coverageDetailsFormStateTempChange.wards_covered.value).length <= 0&& facilityDetailsFormState.rural_urban.value==='Urban') {
                coverageDetailsFormStateTempChange.wards_covered.isError = true;
                coverageDetailsFormStateTempChange.wards_covered.message = 'Select wards from the dropdown.';
                isFormError = true;
              }
              else {
                coverageDetailsFormStateTempChange.wards_covered.isError = false;
              }
            }
            else if (item === 'villages_covered') {
              if (Object.keys(coverageDetailsFormStateTempChange.villages_covered.value).length <= 0 && formData5?.villages_covered?.['#isVisible']&& facilityDetailsFormState.rural_urban.value==='Rural') {
                coverageDetailsFormStateTempChange.villages_covered.isError = true;
                coverageDetailsFormStateTempChange.villages_covered.message = 'Select villages from the dropdown.';
                isFormError = true;
              }
              else {
                coverageDetailsFormStateTempChange.villages_covered.isError = false;
              }
            }
            else if (item === 'gram_panchayat_covered') {
              if (Object.keys(coverageDetailsFormStateTempChange.gram_panchayat_covered.value).length <= 0 && formData5?.gram_panchayat_covered?.['#isVisible']&& facilityDetailsFormState.rural_urban.value==='Rural') {
                coverageDetailsFormStateTempChange.gram_panchayat_covered.isError = true;
                coverageDetailsFormStateTempChange.gram_panchayat_covered.message = 'Select Gram Panchayats / ADC Villages from the dropdown.';
                isFormError = true;
              }
              else {
                coverageDetailsFormStateTempChange.gram_panchayat_covered.isError = false;
              }
            }
          }
        })
        tempError[4] = isFormError;
        setCoverageDetailsFormState(coverageDetailsFormStateTempChange);  
    }
    setErrors(tempError);
  };

  const saveFacilityDetails = async (payload: any) => {
    try {
      const data: any = await manageHealthFacilityJson(JSON.parse(JSON.stringify(payload)), villagesPayLoad, wardsPayLoad, villagesCount, wardsCount)
      const mainPayload = data.mainPayload;
      const combinedChunks: any[] = data.combinedChunks;

      const compressedMainData = pako.gzip(JSON.stringify(mainPayload));
      const encodeCompressedMainData = await uint8ToBase64(compressedMainData);
      let response; 
      if (combinedChunks.length > 0) {
        await postDataJSON<any>(`${endpoints.insertAbdmOrRchFacility}`, {data: encodeCompressedMainData}).then(async (res:any) => {
          if (res?.data && res?.data.length > 0) {
            response = res;
            let subRes: any
            for (const value of combinedChunks) {
              try {
                const compressedDataWithIds = value ? pako.gzip(JSON.stringify({facilityId: res?.data[0].facility_id,
                  stCode: payload.stCode, ...value})) : null;
                const encodeCompressedDataWithIds = compressedDataWithIds ? await uint8ToBase64(compressedDataWithIds) : '';
                subRes = await putDataJSON<any>(`${endpoints.updateAbdmOrRchFacilityWithMoreEntityIds}`, {data: encodeCompressedDataWithIds})
              } catch (err) {
                toast.warning("Some coverage details could not be saved, try again.", {
                  position: "top-center"
                });
              }
            }
            response = subRes ? subRes : res;;
          } else {
            response = res;
          }
        });
      } else {
        response = await postDataJSON<any>(`${endpoints.insertAbdmOrRchFacility}`, {data: encodeCompressedMainData});
      }
      if (response?.data) {
        toast.success((LogedinUserDetails && LogedinUserDetails?.usertype_name === USER_TYPES.DISTRICT_LEVEL_USER && (roleData == roleType.both || roleData == roleType.only_administrator)) ? "Request has been sent for Approval" : "Records have been successfully saved", {
          position: "top-center"
        });
      } else {
        toast.error("Records could not be saved", {
          position: "top-center"
        });
      }
      navigate(`/health-facility`);
      clearMapStore();
    }
    catch (error) {
      toast.error("Records could not be saved", {
        position: "top-center"
      });
    }
  };

  const finishHandler = async () => {

    const ABDMDetailsPayload = {
      abdmFacilityName: ABDMdata.facilityName,
      abdmStatus: ABDMdata.facilityStatus,
      abdmOwnership: ABDMdata.ownership == "Public-Private-Partnership" ? 'PPP' : ABDMdata.ownership,
      abdmOwnershipCode: ABDMdata.ownershipCode,
      abdmSystemOfMedicineCode: ABDMdata.systemOfMedicineCode,
      abdmSystemOfMedicine: ABDMdata.systemOfMedicine,
      abdmFacilityTypeCode: parseInt(ABDMdata.facilityTypeCode?.toString(), 10),
      abdmFacilityType: ABDMdata.facilityType,
      abdmStateName: ABDMdata.stateName,
      abdmStateCode: parseInt(ABDMdata.stateLGDCode?.toString(), 10),
      abdmDistrictName: ABDMdata.districtName,
      abdmDistrictCode: parseInt(ABDMdata.districtLGDCode?.toString(), 10),
      abdmSubDistrictName: ABDMdata.subDistrictName,
      abdmSubDistrictCode: parseInt(ABDMdata.subDistrictLGDCode?.toString(), 10),
      abdmVillageCityTownName: ABDMdata.villageCityTownName,
      abdmVillageCityTownCode: parseInt(ABDMdata.villageCityTownLGDCode?.toString(), 10),
      abdmAddress: ABDMdata.address,
      abdmPincode: ABDMdata.pincode,
      abdmLatitude: parseFloat(ABDMdata.latitude?.toString()),
      abdmLongitude: parseFloat(ABDMdata.longitude?.toString()),
    }

    const ruralFacilityDetails = {
      hfrId: facilityDetailsFormState.hpr_id.value,
      stCode: parseInt(hierarchyDetailsRuralFormState.state.code),
      stId: hierarchyDetailsRuralFormState.state.id,
      distId: hierarchyDetailsRuralFormState.district.id,
      distCode: parseInt(hierarchyDetailsRuralFormState.district.code),
      subDistId: hierarchyDetailsRuralFormState.sub_district.id,
      ulbId: '',
      blockId: hierarchyDetailsRuralFormState.block.id,
      healthBlockId: hierarchyDetailsRuralFormState.health_block.id,
      subDivisionId: hierarchyDetailsRuralFormState.sub_division.id,
      pcId: hierarchyDetailsRuralFormState.parlimentary.id,
      lacId: hierarchyDetailsRuralFormState.lac.id,
      wardId: '',
      villageId: hierarchyDetailsRuralFormState.village.id,
      facilityName: facilityDetailsFormState.facility_name.value ? facilityDetailsFormState.facility_name.value.trim() : '',
      enrollmentDt: new Date(dayjs(enrollmentDetailsFormState.date_of_enrollment.value).format('YYYY-MM-DD')).toISOString().split('T')[0],  //convert to date   
      urbanRualId: facilityDetailsFormState.rural_urban.id,
      facilityTypeId: facilityDetailsFormState.facility_type.id,
      ownershipId: facilityDetailsFormState.ownership.id,
      adminBodyId: facilityDetailsFormState.administrative_body.id,
      categoryId: facilityDetailsFormState.facility_category.id || [],
      centralGovtDeptId: facilityDetailsFormState.central_govt_dept.id,
      statusId: enrollmentDetailsFormState.status.id,
      sanctionedBedCount: parseInt(enrollmentDetailsFormState.sanctionedbed_count.value),
      functionalBedCount: parseInt(enrollmentDetailsFormState.functionalbed_count.value),
      address: locationDetailsFormState.address.value,
      latitude: parseFloat(locationDetailsFormState.lattitude.value),
      longitude: parseFloat(locationDetailsFormState.longitude.value),
      pincode: locationDetailsFormState.pincode.value ? locationDetailsFormState.pincode.value.trim() : '',
      effectiveFromDt: new Date(dayjs(enrollmentDetailsFormState.effective_from_date.value).format('YYYY-MM-DD')).toISOString().split('T')[0],
      villageIds: !isGrampanchayat ? coverageDetailsFormState.villages_covered.id : [],
      wardIds: coverageDetailsFormState.wards_covered.id,
      linkedFacilityIds: coverageDetailsFormState.linked_facilities.id,
      gramPanchayatId: hierarchyDetailsRuralFormState.gram_panchayat.id,
      gramPanchayatIds: isGrampanchayat ? coverageDetailsFormState.gram_panchayat_covered.id : [],
    };

    const urbanFacilityDetails = {
      hfrId: facilityDetailsFormState.hpr_id.value,
      stCode: parseInt(hierarchyDetailsUrbanFormState.state.code),
      stId: hierarchyDetailsUrbanFormState.state.id,
      distId: hierarchyDetailsUrbanFormState.district.id,
      distCode: parseInt(hierarchyDetailsUrbanFormState.district.code),
      subDistId: hierarchyDetailsUrbanFormState.sub_district.id,
      ulbId: hierarchyDetailsUrbanFormState.ulb.id,
      blockId: '',
      healthBlockId: hierarchyDetailsUrbanFormState.health_block.id,
      subDivisionId: hierarchyDetailsUrbanFormState.sub_division.id,
      pcId: hierarchyDetailsUrbanFormState.parlimentary.id,
      lacId: hierarchyDetailsUrbanFormState.lac.id,
      wardId: hierarchyDetailsUrbanFormState.ward.id,
      villageId: '',
      facilityName: facilityDetailsFormState.facility_name.value ? facilityDetailsFormState.facility_name.value.trim() : '',
      enrollmentDt: new Date(dayjs(enrollmentDetailsFormState.date_of_enrollment.value).format('YYYY-MM-DD')).toISOString().split('T')[0],
      urbanRualId: facilityDetailsFormState.rural_urban.id,
      facilityTypeId: facilityDetailsFormState.facility_type.id,
      ownershipId: facilityDetailsFormState.ownership.id,
      adminBodyId: facilityDetailsFormState.administrative_body.id,
      categoryId: facilityDetailsFormState.facility_category.id || [],
      centralGovtDeptId: facilityDetailsFormState.central_govt_dept.id,
      statusId: enrollmentDetailsFormState.status.id,
      sanctionedBedCount: parseInt(enrollmentDetailsFormState.sanctionedbed_count.value),
      functionalBedCount: parseInt(enrollmentDetailsFormState.functionalbed_count.value),
      address: locationDetailsFormState.address.value ? locationDetailsFormState.address.value.trim() : '',
      latitude: parseFloat(locationDetailsFormState.lattitude.value),
      longitude: parseFloat(locationDetailsFormState.longitude.value),
      pincode: locationDetailsFormState.pincode.value,
      effectiveFromDt: new Date(dayjs(enrollmentDetailsFormState.effective_from_date.value).format('YYYY-MM-DD')).toISOString().split('T')[0],
      villageIds: !isGrampanchayat ? coverageDetailsFormState.villages_covered.id : [],
      wardIds: coverageDetailsFormState.wards_covered.id,
      linkedFacilityIds: coverageDetailsFormState.linked_facilities.id,
      gramPanchayatId: '',
      gramPanchayatIds: isGrampanchayat ? coverageDetailsFormState.gram_panchayat_covered.id : [],
    };
    const isRural = facilityDetailsFormState.rural_urban.value === 'Rural';
    const isABDMInsertRequired = facilityDetailsFormState.hpr_id.value ? true : false;
    let payload;
    if (isRural) {
      payload = {
        ...ruralFacilityDetails,
        ...(isABDMInsertRequired ? ABDMDetailsPayload : {}),
        isABDMInsertRequired
      };
    } else {
      payload = {
        ...urbanFacilityDetails,
        ...(isABDMInsertRequired ? ABDMDetailsPayload : {}),
        isABDMInsertRequired
      };
    }
    await saveFacilityDetails(payload);
  }

  useEffect(() => {
    setIsFormValidated(false);
  }, [activeIndex]);

  useEffect(() => {
    if (!errors[activeIndex] && isFormValidated) {
      const newFormCompleted = [...formCompleted];
      newFormCompleted[activeIndex] = true;
      setFormCompleted(newFormCompleted);
      const perc = (activeIndex + 1) * navs;
      setSelectedPerc(perc);
    }
    if (errors[activeIndex] && formCompleted[activeIndex]) {
      const newFormCompleted = [...formCompleted];
      newFormCompleted[activeIndex] = false;
      setFormCompleted(newFormCompleted);
    }
  }, [errors]);

  const handlePrevious = (): void => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
      const newFormCompleted = [...formCompleted];
      newFormCompleted[activeIndex] = false;
      newFormCompleted[activeIndex - 1] = false;
      setFormCompleted(newFormCompleted);
      const perc = (activeIndex - 1) * navs;
      setSelectedPerc(perc);
    }
  };

  const handleSubmit = (): void => {
    handleSave(activeIndex);
    setIsFormValidated(true);
  };
  const handleNavClick = (index: number): void => {
    if (formCompleted[index]) {
      setActiveIndex(index);
    }
  };
  const handleNext = (): void => {
    if (activeIndex < navItemsModal.length - 1) {
      setActiveIndex(activeIndex + 1);
    } else if (activeIndex === navItemsModal.length - 1) {
      setSelectedPerc(selectPerc + navs);
    }
  };
  const [closeModal, setCloseModal] = useState<boolean>(false)
  const CloseFacility = () => {
    setCloseModal(true);
  }
  const closeCreateModal = (value: boolean) => {
    if (value) {
      setCloseModal(false);
      clearMapStore();
      navigate(`/health-facility`);
    }
    else {
      setCloseModal(false);

    }
  }
  const onHandleBackArrowButton = () => {
    navigate(`/health-facility`);
    clearMapStore();
  }

  const breadcrumbItemName = [
    { value: page, label: 'Health Facility' },
    { value: page, label: 'Health Facility Maintenance' },
  ]

  return (
    <div>
      <WithPermission moduleCode="FcltyMgmt" pageCode='FcltyMgmt_CrPg' privilege="create">
        <CreateCommonComponent
          breadcrumbItemName={breadcrumbItemName}
          onHandleBackArrowButton={onHandleBackArrowButton}
          navItemsModal={navItemsModal}
          activeIndex={activeIndex}
          handleNavClick={handleNavClick}
          formCompleted={formCompleted}
          headerName={"Create a new Facility"}
          progressBarPerc={selectPerc}
          contents={contents}
          handlePrevious={handlePrevious}
          handleSubmit={handleSubmit}
          finishHandler={finishHandler}
          handleNext={handleNext}
          handleCancel={CloseFacility}
          closeCreateModal={closeCreateModal}
          closeModal={closeModal} />
      </WithPermission>
    </div>
  );
};

export default CreateNewFacility;
